import { __decorate, __param } from 'tslib';
import { EventEmitter, Input, Output, HostListener, Directive, ElementRef, Renderer2, Inject, Pipe, ɵɵdefineInjectable, ɵɵinject, Injectable, Component, ViewEncapsulation, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, throwError, Observable } from 'rxjs';
import { debounceTime, catchError, tap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpParams, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@ngx-translate/core';

function SpinnerButtonComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelement(2, "span", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function PaginationComponent_li_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 9);
    ɵngcc0.ɵɵelementStart(1, "a", 10);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_li_9_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const item_r2 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.goTo(item_r2); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.pageNumber === item_r2 ? "active" : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r2);
} }
const _c0 = function (a1) { return ["snackbar-wrap", a1]; };
function SnackbarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "p", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@state", undefined)("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, ctx_r0.type));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.message, " ");
} }
let DebounceClickDirective = class DebounceClickDirective {
    constructor() {
        this.debounceTime = 500;
        this.debounceClick = new EventEmitter();
        this.clicks = new Subject();
    }
    ngOnInit() {
        this.subscription = this.clicks.pipe(debounceTime(this.debounceTime)).subscribe((e) => this.debounceClick.emit(e));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    clickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }
};
DebounceClickDirective.ɵfac = function DebounceClickDirective_Factory(t) { return new (t || DebounceClickDirective)(); };
DebounceClickDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DebounceClickDirective, selectors: [["", "debounceClick", ""]], hostBindings: function DebounceClickDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DebounceClickDirective_click_HostBindingHandler($event) { return ctx.clickEvent($event); });
    } }, inputs: { debounceTime: "debounceTime" }, outputs: { debounceClick: "debounceClick" } });
__decorate([
    Input()
], DebounceClickDirective.prototype, "debounceTime", void 0);
__decorate([
    Output()
], DebounceClickDirective.prototype, "debounceClick", void 0);
__decorate([
    HostListener('click', ['$event'])
], DebounceClickDirective.prototype, "clickEvent", null);

let HiddenOnProdDirective = class HiddenOnProdDirective {
    constructor(el, renderer, env) {
        if (!env.production) {
            renderer.setStyle(el.nativeElement, 'display', 'visible');
        }
        else {
            renderer.setStyle(el.nativeElement, 'display', 'none');
        }
    }
};
HiddenOnProdDirective.ɵfac = function HiddenOnProdDirective_Factory(t) { return new (t || HiddenOnProdDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject('env')); };
HiddenOnProdDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: HiddenOnProdDirective, selectors: [["", "hiddenOnProd", ""]] });
HiddenOnProdDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
HiddenOnProdDirective = __decorate([ __param(2, Inject('env'))
], HiddenOnProdDirective);

let CardNumberPipe = class CardNumberPipe {
    transform(value) {
        if (value == null) {
            return '';
        }
        else {
            return this.chunk(value, 4);
        }
    }
    chunk(str, n) {
        str = str.replace(/-/g, '');
        const ret = [];
        let i;
        let len;
        for (i = 0, len = str.length; i < len; i += n) {
            ret.push(str.substr(i, n));
        }
        return ret.join('-');
    }
};
CardNumberPipe.ɵfac = function CardNumberPipe_Factory(t) { return new (t || CardNumberPipe)(); };
CardNumberPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cardNumber", type: CardNumberPipe, pure: true });

const ITEM_SCOPE = 'scopes';
const ITEM_TOKEN = 'token';
const ITEM_EXPIRES = 'expires';
const ITEM_USER = 'user';
const EMPLOYEE_ID = 'employeeId';
const HOLDER_ID = 'holderId';
const USER_ID = 'id';
const LOGIN = 'login';
const PROFILE = 'profile';
const TARGET = 'taget';

function findHolderId(table, codeApplication) {
    if (table !== undefined && table.length !== 0) {
        const result = table.filter((holder) => holder.productId === codeApplication);
        if (result[0] && result[0].id) {
            return result[0].id;
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}
function findProfile(table, applicationId) {
    const result = table.filter((profile) => profile.applicationId === applicationId);
    return result[0].type;
}

function dateFormat(d) {
    if (d) {
        const date = new Date(d);
        return date.getFullYear() + '-' + appendLeadingZeroes(date.getMonth() + 1) + '-' + appendLeadingZeroes(date.getDate());
    }
}
function dateFormatForScreen(d) {
    if (d) {
        const date = new Date(d);
        return appendLeadingZeroes(date.getDate()) + '/' + appendLeadingZeroes(date.getMonth() + 1) + '/' + date.getFullYear();
    }
}
function toMMYY(date) {
    if (date) {
        const d = new Date(date);
        const year = d
            .getFullYear()
            .toString()
            .substring(2, 4);
        const month = appendLeadingZeroes(+d.getMonth() + 1);
        return month + year;
    }
}
function getMonthName(date) {
    if (date) {
        const d = new Date(date);
        const monthNames = [
            'Janvier',
            'Février',
            'Mars',
            'Avril',
            'Mai',
            'Juin',
            'Juillet',
            'Août',
            'Septembre',
            'Octobre',
            'Novembre',
            'Décembre'
        ];
        return monthNames[d.getMonth()];
    }
}
function getDayName(d) {
    if (d) {
        const date = new Date(d);
        const today = new Date();
        const yesterday = new Date().setDate(today.getDate() - 1);
        if (dateFormat(date) === dateFormat(today)) {
            return 'Aujourdhui';
        }
        if (dateFormat(date) === dateFormat(yesterday)) {
            return 'Hier';
        }
        return date.getDate() + ' ' + getMonthName(date) + ' ' + date.getFullYear();
    }
}
function appendLeadingZeroes(n) {
    if (n <= 9) {
        return '0' + n;
    }
    return n;
}

let UserService = class UserService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'user/') + env.versionApi + '/users/';
        this.urlEmployee = '/NIT/' + (env.localApi ? '' : 'user/') + env.versionApi + '/employees/';
        this.appId = env.applicationId;
    }
    findMe() {
        return this.http.get(this.url + 'me');
    }
    patchMe(login, currentPassword, newPassword) {
        return this.http.patch(this.url + 'me', {
            applicationId: this.appId,
            login,
            currentPassword,
            newPassword
        });
    }
    /**
     * @deprecated
     */
    find(pCardNumber, pExpirationDate) {
        return this.http.get(this.url, { params: { cardNumber: pCardNumber, expirationDate: pExpirationDate } });
    }
    readByCriteria(userCriteria) {
        let params = new HttpParams();
        if (userCriteria.cardNumber) {
            params = params.append('cardNumber', userCriteria.cardNumber);
        }
        if (userCriteria.expirationDate) {
            params = params.append('expirationDate', userCriteria.expirationDate);
        }
        if (userCriteria.login) {
            params = params.append('login', userCriteria.login);
        }
        if (userCriteria.employeePersonalCode) {
            params = params.append('employeePersonalCode', userCriteria.employeePersonalCode);
        }
        if (userCriteria.productId) {
            params = params.append('productId', userCriteria.productId);
        }
        if (userCriteria.birthDate) {
            params = params.append('birthDate', dateFormat(userCriteria.birthDate));
        }
        return this.http.get(this.url, { params });
    }
    createUserAccount(employeeId, user) {
        return this.http.post(this.urlEmployee + employeeId + '/users', user);
    }
    readTermsAndConditionsAcceptances(userId) {
        return this.http.get(this.url + userId + '/termsAndConditionsAcceptances/latest');
    }
    createTermsAndConditionsAcceptances(userId, profileType) {
        return this.http.post(this.url + userId + '/termsAndConditionsAcceptances', profileType);
    }
};
UserService.ɵfac = function UserService_Factory(t) { return new (t || UserService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
UserService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
UserService.ɵprov = ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: UserService, providedIn: "root" });
UserService = __decorate([ __param(1, Inject('env'))
], UserService);

const URL_AUTORISATION = '/api/oauth/nit/authorize';
const URL_REVOKE_TOKEN = '/api/oauth/revoke';
const GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:saml2-bearer';
const REPONSE_TYPE = 'text';
const REDIRECT_URI = 'token';
let AuthentificationService = class AuthentificationService {
    constructor(http, userService, router, env) {
        this.http = http;
        this.userService = userService;
        this.router = router;
        this.env = env;
        this.env.urlRedirect = env.redirectURL;
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            alert(`An error occurred: ${error.error.message}`);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            alert(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened; please try again later.');
    }
    authentificate(clientId, responseType) {
        let params = new HttpParams();
        params = params.set('client_id', clientId);
        params = params.set('redirect_uri', this.env.redirectURL + REDIRECT_URI);
        params = params.set('response_type', responseType);
        params = params.set('grant_type', GRANT_TYPE);
        return this.http.get(URL_AUTORISATION, { params, responseType: REPONSE_TYPE }).pipe(catchError(this.handleError));
    }
    revokeToken(clientIdGateway, logoutURL) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Basic ' + btoa(clientIdGateway + ':'),
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };
        return this.http.post('/api/oauth/revoke', 'token=' + sessionStorage.getItem('token'), httpOptions).subscribe(() => {
            sessionStorage.clear();
            if (logoutURL) {
                this.router.navigateByUrl(logoutURL);
            }
        }, error => {
            throw new Error('REVOKE TOKEN FAILED : ' + error);
        });
    }
    isAuthenticated() {
        if (this.getToken() == null || this.getToken().length === 0) {
            return false;
        }
        else {
            return true;
        }
    }
    getToken() {
        return sessionStorage.getItem(ITEM_TOKEN);
    }
    initSessionStorage(tokenValue, expiresIn, typeToken) {
        sessionStorage.setItem(ITEM_TOKEN, tokenValue);
        sessionStorage.setItem(ITEM_EXPIRES, expiresIn);
        sessionStorage.setItem(ITEM_SCOPE, typeToken);
        return this.userService
            .findMe()
            .pipe(tap(data => {
            sessionStorage.setItem(ITEM_USER, JSON.stringify(data));
            sessionStorage.setItem(EMPLOYEE_ID, (data.employee ? data.employee.id : ''));
            sessionStorage.setItem(LOGIN, data.login);
            sessionStorage.setItem(HOLDER_ID, findHolderId(data.holders, this.env.codeProduit));
            sessionStorage.setItem(PROFILE, findProfile(data.profiles, this.env.applicationId));
            sessionStorage.setItem(USER_ID, data.id);
        }));
    }
    logout(logoutURL, clientIdGateway) {
        this.revokeToken(clientIdGateway, logoutURL);
    }
};
AuthentificationService.ɵfac = function AuthentificationService_Factory(t) { return new (t || AuthentificationService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(UserService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject('env')); };
AuthentificationService.ctorParameters = () => [
    { type: HttpClient },
    { type: UserService },
    { type: Router },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
AuthentificationService.ɵprov = ɵɵdefineInjectable({ factory: function AuthentificationService_Factory() { return new AuthentificationService(ɵɵinject(HttpClient), ɵɵinject(UserService), ɵɵinject(Router), ɵɵinject("env")); }, token: AuthentificationService, providedIn: "root" });
AuthentificationService = __decorate([ __param(3, Inject('env'))
], AuthentificationService);

let TokenComponent = class TokenComponent {
    constructor(route, authenticationService) {
        this.route = route;
        this.authenticationService = authenticationService;
        route.fragment.subscribe(fragment => {
            const params = new URLSearchParams(fragment);
            this.accessTokenValue = params.get('access_token');
            this.expiresInValue = params.get('expires_in');
            this.scopesValue = params.get('scopes');
            this.tokenTypeValue = params.get('token_type');
        });
    }
    findUser() {
        return this.authenticationService
            .initSessionStorage(this.accessTokenValue, this.expiresInValue, this.tokenTypeValue);
    }
};
TokenComponent.ɵfac = function TokenComponent_Factory(t) { return new (t || TokenComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(AuthentificationService)); };
TokenComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TokenComponent, selectors: [["nit-token-response"]], decls: 0, vars: 0, template: function TokenComponent_Template(rf, ctx) { }, encapsulation: 2 });
TokenComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: AuthentificationService }
];

const REPONSE_TYPE$1 = 'token';
const NOM_FORMULAIRE = 'form';
let AuthentificationComponent = class AuthentificationComponent {
    constructor(authentificationService, env) {
        this.authentificationService = authentificationService;
        this.env = env;
        this.clientIdGateway = env.clientIdGateway;
    }
    ngOnInit() {
        this.authentificationService
            .authentificate(this.clientIdGateway, REPONSE_TYPE$1)
            .subscribe((contenuHtml) => this.setPageHtml(contenuHtml));
    }
    setPageHtml(html) {
        document.body.innerHTML = html;
        const form = document.getElementsByTagName(NOM_FORMULAIRE)[0];
        form.submit();
    }
};
AuthentificationComponent.ɵfac = function AuthentificationComponent_Factory(t) { return new (t || AuthentificationComponent)(ɵngcc0.ɵɵdirectiveInject(AuthentificationService), ɵngcc0.ɵɵdirectiveInject('env')); };
AuthentificationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthentificationComponent, selectors: [["app-token"]], decls: 9, vars: 0, consts: [[1, "card"], [1, "card-header"], [1, "card-body"]], template: function AuthentificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h2");
        ɵngcc0.ɵɵtext(3, "Authentification");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div");
        ɵngcc0.ɵɵelementStart(6, "label");
        ɵngcc0.ɵɵtext(7, "Redirection automatique vers la page de connexion");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "br");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
AuthentificationComponent.ctorParameters = () => [
    { type: AuthentificationService },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
AuthentificationComponent = __decorate([ __param(1, Inject('env'))
], AuthentificationComponent);

let DeconnexionComponent = class DeconnexionComponent {
    constructor(authentificationService, router, env) {
        this.authentificationService = authentificationService;
        this.router = router;
        this.env = env;
        this.url = env.logoutURL;
        this.clientIdGateway = env.clientIdGateway;
    }
    ngOnInit() {
        this.authentificationService.revokeToken(this.clientIdGateway, this.url);
    }
};
DeconnexionComponent.ɵfac = function DeconnexionComponent_Factory(t) { return new (t || DeconnexionComponent)(ɵngcc0.ɵɵdirectiveInject(AuthentificationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject('env')); };
DeconnexionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DeconnexionComponent, selectors: [["nit-deconnexion"]], decls: 2, vars: 0, template: function DeconnexionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "Deconnexion");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DeconnexionComponent.ctorParameters = () => [
    { type: AuthentificationService },
    { type: Router },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
DeconnexionComponent = __decorate([ __param(2, Inject('env'))
], DeconnexionComponent);

let CreditCardComponent = class CreditCardComponent {
    constructor() { }
    ngOnInit() {
        if (this.backGround === undefined) {
            this.backGround = '';
        }
    }
};
CreditCardComponent.ɵfac = function CreditCardComponent_Factory(t) { return new (t || CreditCardComponent)(); };
CreditCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CreditCardComponent, selectors: [["nit-credit-card"]], inputs: { backGround: "backGround", logoTypeCard: "logoTypeCard", namePorteur: "namePorteur", expirationDate: "expirationDate", cardNumber: "cardNumber", puce: "puce", sansContact: "sansContact", logo1: "logo1", logo2: "logo2", logo3: "logo3" }, decls: 22, vars: 11, consts: [[1, "container", "d-flex", "justify-content-center"], [1, "card"], [1, "logo", "d-flex", "justify-content-between"], [1, "logo1", 3, "src"], [1, "logo2", 3, "src"], [1, "logo3", 3, "src"], [1, "triangle"], [1, "puce", 3, "src"], [1, "sansContact", 3, "src"], [1, "name"], [1, "expiration", "d-flex", "justify-content-start"], [1, "labelExpire"], [1, "dateExpire"], [1, "number"], [1, "visa", 3, "src"]], template: function CreditCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵelement(4, "img", 4);
        ɵngcc0.ɵɵelement(5, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "div", 6);
        ɵngcc0.ɵɵelement(7, "img", 7);
        ɵngcc0.ɵɵelement(8, "img", 8);
        ɵngcc0.ɵɵelementStart(9, "div", 9);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "div", 11);
        ɵngcc0.ɵɵtext(13, "EXPIRE ");
        ɵngcc0.ɵɵelement(14, "br");
        ɵngcc0.ɵɵtext(15, "A FIN");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 12);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 13);
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div");
        ɵngcc0.ɵɵelement(21, "img", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("background-image", "url(" + ctx.backGround + ")");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logo1, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logo2, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logo3, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.puce, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.sansContact, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.namePorteur, " ");
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate(ctx.expirationDate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.cardNumber, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoTypeCard, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: [".card[_ngcontent-%COMP%]{width:300px;height:200px;border-radius:12px;color:#fff}.name[_ngcontent-%COMP%]{position:absolute;top:80%;left:50px}.expiration[_ngcontent-%COMP%]{position:absolute;top:67%;left:50%}.number[_ngcontent-%COMP%]{font-family:Halter;letter-spacing:2px;position:absolute;top:55%;left:50px}.puce[_ngcontent-%COMP%]{position:absolute;top:30%;left:50px;width:40px}.sansContact[_ngcontent-%COMP%]{position:absolute;top:27%;left:110px;width:40px}.visa[_ngcontent-%COMP%]{width:50px;position:absolute;right:5%;bottom:5%}.logo[_ngcontent-%COMP%]{width:100%;padding-left:50px;padding-right:50px;padding-top:6px}.logo1[_ngcontent-%COMP%], .logo2[_ngcontent-%COMP%], .logo3[_ngcontent-%COMP%]{width:30px}.labelExpire[_ngcontent-%COMP%]{font-size:7px;padding-right:8px}.triangle[_ngcontent-%COMP%]{position:absolute;width:0;height:0;top:60%;left:10px;border-top:30px solid transparent;border-bottom:30px solid transparent;border-right:20px solid #fff}"] });
__decorate([
    Input()
], CreditCardComponent.prototype, "logoTypeCard", void 0);
__decorate([
    Input()
], CreditCardComponent.prototype, "namePorteur", void 0);
__decorate([
    Input()
], CreditCardComponent.prototype, "expirationDate", void 0);
__decorate([
    Input()
], CreditCardComponent.prototype, "cardNumber", void 0);
__decorate([
    Input()
], CreditCardComponent.prototype, "puce", void 0);
__decorate([
    Input()
], CreditCardComponent.prototype, "sansContact", void 0);
__decorate([
    Input()
], CreditCardComponent.prototype, "logo1", void 0);
__decorate([
    Input()
], CreditCardComponent.prototype, "logo2", void 0);
__decorate([
    Input()
], CreditCardComponent.prototype, "logo3", void 0);
__decorate([
    Input()
], CreditCardComponent.prototype, "backGround", void 0);

let SpinnerButtonComponent = class SpinnerButtonComponent {
    constructor() {
        this.clicked = new EventEmitter();
    }
    submit() {
        this.clicked.emit();
    }
};
SpinnerButtonComponent.ɵfac = function SpinnerButtonComponent_Factory(t) { return new (t || SpinnerButtonComponent)(); };
SpinnerButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SpinnerButtonComponent, selectors: [["nit-spinner-button"]], inputs: { label: "label", disabled: "disabled", isLoading: "isLoading", css: "css" }, outputs: { clicked: "clicked" }, decls: 3, vars: 4, consts: [["debounceClick", "", "type", "button", 1, "position-relative", 3, "ngClass", "disabled", "debounceClick"], ["class", "spinner-loader", 4, "ngIf"], [1, "spinner-loader"], ["role", "status", 1, "spinner-border", "spinner-border-sm"], [1, "sr-only"]], template: function SpinnerButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("debounceClick", function SpinnerButtonComponent_Template_button_debounceClick_0_listener() { return ctx.submit(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵtemplate(2, SpinnerButtonComponent_div_2_Template, 3, 0, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.css)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoading);
    } }, directives: [DebounceClickDirective, ɵngcc3.NgClass, ɵngcc3.NgIf], styles: [".spinner-loader[_ngcontent-%COMP%]{position:absolute;right:10%;top:20%}"] });
__decorate([
    Input()
], SpinnerButtonComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpinnerButtonComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], SpinnerButtonComponent.prototype, "isLoading", void 0);
__decorate([
    Input()
], SpinnerButtonComponent.prototype, "css", void 0);
__decorate([
    Output()
], SpinnerButtonComponent.prototype, "clicked", void 0);

let FormDiagnosticComponent = class FormDiagnosticComponent {
    constructor() { }
    diagnostic() {
        if (this.form) {
            console.log('------------------');
            console.log('### DIAGNOSTIC ###');
            console.log('valid:', this.form.valid);
            console.log('status:', this.form.status);
            console.log('value:', this.form.value);
            console.log('errors:', this.getListErrors());
            console.log('details:', this.form);
            console.log('date:', new Date());
            console.log('------------------');
        }
        else {
            throw new Error('No form available!');
        }
    }
    getListErrors() {
        const errorList = [];
        Object.keys(this.form.controls).forEach((key) => {
            if (this.form.get(key).errors) {
                errorList.push(key);
            }
        });
        return errorList;
    }
};
FormDiagnosticComponent.ɵfac = function FormDiagnosticComponent_Factory(t) { return new (t || FormDiagnosticComponent)(); };
FormDiagnosticComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormDiagnosticComponent, selectors: [["nit-form-diagnostic"]], inputs: { form: "form" }, decls: 2, vars: 0, consts: [["type", "button", "appHiddenOnProd", "", 1, "btn", "btn-danger", 3, "click"]], template: function FormDiagnosticComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function FormDiagnosticComponent_Template_button_click_0_listener() { return ctx.diagnostic(); });
        ɵngcc0.ɵɵtext(1, " Diagnostic\n");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
__decorate([
    Input()
], FormDiagnosticComponent.prototype, "form", void 0);

let PaginationComponent = class PaginationComponent {
    constructor() {
        this.changePage = new EventEmitter();
    }
    goTo(pageNumber) {
        if (pageNumber >= 1 && pageNumber <= this.totalPages) {
            this.changePage.emit(pageNumber);
        }
    }
    createRange(nb) {
        const items = [];
        for (let i = 1; i <= nb; i++) {
            items.push(i);
        }
        return items;
    }
};
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(); };
PaginationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["nit-pagination"]], inputs: { pageNumber: "pageNumber", totalPages: "totalPages" }, outputs: { changePage: "changePage" }, decls: 16, vars: 1, consts: [["aria-label", "pagination"], ["pagination", ""], [1, "pagination", "justify-content-center"], [1, "page-item"], ["aria-label", "Pr\u00E9c\u00E9dent", 1, "page-link", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], ["class", "page-item", 3, "ngClass", 4, "ngFor", "ngForOf"], ["aria-label", "Suivant", 1, "page-link", 3, "click"], [1, "page-item", 3, "ngClass"], [1, "page-link", 3, "click"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "ul", 2);
        ɵngcc0.ɵɵelementStart(3, "li", 3);
        ɵngcc0.ɵɵelementStart(4, "a", 4);
        ɵngcc0.ɵɵlistener("click", function PaginationComponent_Template_a_click_4_listener() { return ctx.goTo(+ctx.pageNumber - 1); });
        ɵngcc0.ɵɵelementStart(5, "span", 5);
        ɵngcc0.ɵɵtext(6, "\u00AB");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵtext(8, "Pr\u00E9c\u00E9dent");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, PaginationComponent_li_9_Template, 3, 2, "li", 7);
        ɵngcc0.ɵɵelementStart(10, "li", 3);
        ɵngcc0.ɵɵelementStart(11, "a", 8);
        ɵngcc0.ɵɵlistener("click", function PaginationComponent_Template_a_click_11_listener() { return ctx.goTo(+ctx.pageNumber + 1); });
        ɵngcc0.ɵɵelementStart(12, "span", 5);
        ɵngcc0.ɵɵtext(13, "\u00BB");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "span", 6);
        ɵngcc0.ɵɵtext(15, "Suivant");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.createRange(ctx.totalPages));
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgClass], encapsulation: 2 });
__decorate([
    Input()
], PaginationComponent.prototype, "pageNumber", void 0);
__decorate([
    Input()
], PaginationComponent.prototype, "totalPages", void 0);
__decorate([
    Output()
], PaginationComponent.prototype, "changePage", void 0);

let SnackbarService = class SnackbarService {
    constructor() {
        this.snackbarSubject = new Subject();
        this.snackbarState = this.snackbarSubject.asObservable();
    }
    show(message, type) {
        this.snackbarSubject.next({
            show: true,
            message,
            type
        });
    }
    showSuccess(message) {
        this.snackbarSubject.next({
            show: true,
            message,
            type: 'success'
        });
    }
    showDanger(message) {
        this.snackbarSubject.next({
            show: true,
            message,
            type: 'danger'
        });
    }
};
SnackbarService.ɵfac = function SnackbarService_Factory(t) { return new (t || SnackbarService)(); };
SnackbarService.ɵprov = ɵɵdefineInjectable({ factory: function SnackbarService_Factory() { return new SnackbarService(); }, token: SnackbarService, providedIn: "root" });

let SnackbarComponent = class SnackbarComponent {
    constructor(snackbarService) {
        this.snackbarService = snackbarService;
        this.show = false;
        this.type = 'success';
    }
    ngOnInit() {
        this.snackbarSubscription = this.snackbarService.snackbarState.subscribe((state) => {
            if (state.type) {
                this.type = state.type;
            }
            else {
                this.type = 'success';
            }
            this.message = state.message;
            this.show = state.show;
            setTimeout(() => {
                this.show = false;
            }, 3000);
        });
    }
    ngOnDestroy() {
        this.snackbarSubscription.unsubscribe();
    }
};
SnackbarComponent.ɵfac = function SnackbarComponent_Factory(t) { return new (t || SnackbarComponent)(ɵngcc0.ɵɵdirectiveInject(SnackbarService)); };
SnackbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SnackbarComponent, selectors: [["nit-snackbar"]], decls: 1, vars: 1, consts: [[3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "snackbar-text"]], template: function SnackbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SnackbarComponent_div_0_Template, 3, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgClass], styles: [".snackbar-wrap[_ngcontent-%COMP%]{position:fixed;bottom:50px;left:50%;padding:20px 0;border-radius:5px;min-width:20%;-webkit-transform-origin:center center;transform-origin:center center;-webkit-transform:translate(-50%,0);transform:translate(-50%,0)}.snackbar-wrap.success[_ngcontent-%COMP%]{background:#7ed321}.snackbar-wrap.danger[_ngcontent-%COMP%]{background:#ff3951}.snackbar-wrap[_ngcontent-%COMP%]   .snackbar-text[_ngcontent-%COMP%]{text-align:center;font-size:1.3em;color:#fff;margin:0}"], data: { animation: [
            trigger('state', [
                transition(':enter', [
                    style({ bottom: '-100px', transform: 'translate(-50%, 0%) scale(0.3)' }),
                    animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({
                        transform: 'translate(-50%, 0%) scale(1)',
                        opacity: 1,
                        bottom: '20px'
                    }))
                ]),
                transition(':leave', [
                    animate('150ms cubic-bezier(0.4, 0.0, 1, 1)', style({
                        transform: 'translate(-50%, 0%) scale(0.3)',
                        opacity: 0,
                        bottom: '-100px'
                    }))
                ])
            ])
        ] } });
SnackbarComponent.ctorParameters = () => [
    { type: SnackbarService }
];

let CardStatusPipe = class CardStatusPipe {
    transform(value, ...args) {
        switch (value) {
            case 'MANUFACTURING_ASKED': {
                return 'En fabrication';
            }
            case 'SHIPPED': {
                return 'Expédiée';
            }
            case 'ACTIVED': {
                return 'Activée';
            }
            case 'ACTIVATED': {
                return 'Active';
            }
            case 'RENEWAL_ASKED': {
                return 'Renouvellement en cours';
            }
            case 'REMANUFACTURING_ASKED': {
                return 'En refabrication';
            }
            case 'MANUFACTURED': {
                return 'Fabriquée';
            }
            case 'DISABLED': {
                return 'Désactivée temporairement';
            }
            case 'BLOCKED': {
                return 'Bloquée';
            }
            case 'EXPIRED': {
                return 'Expirée';
            }
            default: {
                return 'Inconnu';
            }
        }
    }
};
CardStatusPipe.ɵfac = function CardStatusPipe_Factory(t) { return new (t || CardStatusPipe)(); };
CardStatusPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cardStatus", type: CardStatusPipe, pure: true });

let BeneficiaryStatusPipe = class BeneficiaryStatusPipe {
    transform(value, ...args) {
        switch (value) {
            case 'ACTIVE': {
                return 'Actif';
            }
            case 'INACTIVE': {
                return 'Inactif';
            }
            default: {
                return '';
            }
        }
    }
};
BeneficiaryStatusPipe.ɵfac = function BeneficiaryStatusPipe_Factory(t) { return new (t || BeneficiaryStatusPipe)(); };
BeneficiaryStatusPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "beneficiaryStatus", type: BeneficiaryStatusPipe, pure: true });

let DragAndDropDirective = class DragAndDropDirective {
    constructor() {
        this.fileDropped = new EventEmitter();
        this.background = 'transparent';
        this.opacity = '1';
    }
    // Dragover listener
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#9ecbec';
        this.opacity = '0.8';
    }
    // Dragleave listener
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#f5fcff';
        this.opacity = '1';
    }
    // Drop listener
    ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#f5fcff';
        this.opacity = '1';
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
};
DragAndDropDirective.ɵfac = function DragAndDropDirective_Factory(t) { return new (t || DragAndDropDirective)(); };
DragAndDropDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DragAndDropDirective, selectors: [["", "nitDragDrop", ""]], hostVars: 4, hostBindings: function DragAndDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragover", function DragAndDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function DragAndDropDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); })("drop", function DragAndDropDirective_drop_HostBindingHandler($event) { return ctx.ondrop($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("background-color", ctx.background)("opacity", ctx.opacity);
    } }, outputs: { fileDropped: "fileDropped" } });
__decorate([
    Output()
], DragAndDropDirective.prototype, "fileDropped", void 0);
__decorate([
    HostBinding('style.background-color')
], DragAndDropDirective.prototype, "background", void 0);
__decorate([
    HostBinding('style.opacity')
], DragAndDropDirective.prototype, "opacity", void 0);
__decorate([
    HostListener('dragover', ['$event'])
], DragAndDropDirective.prototype, "onDragOver", null);
__decorate([
    HostListener('dragleave', ['$event'])
], DragAndDropDirective.prototype, "onDragLeave", null);
__decorate([
    HostListener('drop', ['$event'])
], DragAndDropDirective.prototype, "ondrop", null);

var NitAngularLibModule_1;
let NitAngularLibModule = NitAngularLibModule_1 = class NitAngularLibModule {
    static forRoot(environment) {
        return {
            ngModule: NitAngularLibModule_1,
            providers: [
                {
                    provide: 'env',
                    useValue: environment
                }
            ]
        };
    }
};
NitAngularLibModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NitAngularLibModule });
NitAngularLibModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NitAngularLibModule_Factory(t) { return new (t || NitAngularLibModule)(); }, imports: [[CommonModule], CommonModule] });

const ASC = 'asc';
const CODE = 'code';
const DESC = 'desc';
const LABEL = 'label';
const NUMBER = 'number';

var AffiliateTypeEnum;
(function (AffiliateTypeEnum) {
    AffiliateTypeEnum["PERSON"] = "PERSON";
    AffiliateTypeEnum["COMPANY"] = "COMPANY";
})(AffiliateTypeEnum || (AffiliateTypeEnum = {}));

var TitleEnum;
(function (TitleEnum) {
    TitleEnum["MR"] = "MR";
    TitleEnum["MME"] = "MME";
})(TitleEnum || (TitleEnum = {}));
var PaymentMethodEnum;
(function (PaymentMethodEnum) {
    PaymentMethodEnum["CHQ"] = "CHQ";
    PaymentMethodEnum["VIR"] = "VIR";
})(PaymentMethodEnum || (PaymentMethodEnum = {}));
var ActiveInactiveEnum;
(function (ActiveInactiveEnum) {
    ActiveInactiveEnum["ACTIVE"] = "ACTIVE";
    ActiveInactiveEnum["INACTIVE"] = "INACTIVE";
})(ActiveInactiveEnum || (ActiveInactiveEnum = {}));

var ConditionTransitionEnum;
(function (ConditionTransitionEnum) {
    ConditionTransitionEnum["OK"] = "OK";
    ConditionTransitionEnum["KO"] = "KO";
    ConditionTransitionEnum["RETURN"] = "RETURN";
})(ConditionTransitionEnum || (ConditionTransitionEnum = {}));

var CustomerStatusCardEnum;
(function (CustomerStatusCardEnum) {
    CustomerStatusCardEnum["MANUFACTURING_ASKED"] = "MANUFACTURING_ASKED";
    CustomerStatusCardEnum["SHIPPED"] = "SHIPPED";
    CustomerStatusCardEnum["ACTIVATED"] = "ACTIVATED";
    CustomerStatusCardEnum["RENEWAL_ASKED"] = "RENEWAL_ASKED";
    CustomerStatusCardEnum["EXPIRED"] = "EXPIRED";
    CustomerStatusCardEnum["BLOCKED"] = "BLOCKED";
    CustomerStatusCardEnum["DISABLED"] = "DISABLED";
    CustomerStatusCardEnum["REMANUFACTURING_ASKED"] = "REMANUFACTURING_ASKED";
    CustomerStatusCardEnum["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
})(CustomerStatusCardEnum || (CustomerStatusCardEnum = {}));

var DeliveryTypeEnum;
(function (DeliveryTypeEnum) {
    DeliveryTypeEnum["VOUCHERS"] = "VOUCHERS";
    DeliveryTypeEnum["CARD"] = "CARD";
    DeliveryTypeEnum["PIN_CODE"] = "PIN_CODE";
})(DeliveryTypeEnum || (DeliveryTypeEnum = {}));

var DestinationEnum;
(function (DestinationEnum) {
    DestinationEnum["HOME"] = "HOME";
    DestinationEnum["CUSTOMER"] = "CUSTOMER";
})(DestinationEnum || (DestinationEnum = {}));

var IncludeEnum;
(function (IncludeEnum) {
    IncludeEnum["STAFFING_AND_VALUE_SETTING"] = "STAFFING_AND_VALUE_SETTING";
})(IncludeEnum || (IncludeEnum = {}));

var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum["ENGLISH"] = "en";
    LanguageEnum["FRENCH"] = "fr";
})(LanguageEnum || (LanguageEnum = {}));

var merchantCategoryEnum;
(function (merchantCategoryEnum) {
    merchantCategoryEnum["BUTCHER_DELICATESSEN"] = "Boucherie";
    merchantCategoryEnum["HYPERMARKET"] = "Supermarch\u00E9";
    merchantCategoryEnum["SUPERMARKET"] = "Supermarch\u00E9";
    merchantCategoryEnum["FROZEN_PRODUCTS"] = "Supermarch\u00E9";
    merchantCategoryEnum["BAKERY_PASTRY"] = "Boulangerie";
    merchantCategoryEnum["CATERERS"] = "Traiteur";
    merchantCategoryEnum["TRADITIONAL"] = "Restaurant";
    merchantCategoryEnum["LICENSED_PUB"] = "Bars";
    merchantCategoryEnum["FAST_FOOD"] = "Fast food";
    merchantCategoryEnum["HOTEL"] = "H\u00F4tel";
    merchantCategoryEnum["OTHER"] = "Autre";
})(merchantCategoryEnum || (merchantCategoryEnum = {}));

var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum["DELETED"] = "DELETED";
    OrderStatusEnum["DRAFT"] = "DRAFT";
    OrderStatusEnum["CREATION_IN_PROGRESS"] = "CREATION_IN_PROGRESS";
    OrderStatusEnum["PREPARATION_IN_PROGRESS"] = "PREPARATION_IN_PROGRESS";
    OrderStatusEnum["MANUFACTURING_IN_PROGRESS"] = "MANUFACTURING_IN_PROGRESS";
    OrderStatusEnum["PREPARED"] = "PREPARED";
    OrderStatusEnum["SHIPPED"] = "SHIPPED";
    OrderStatusEnum["VALIDATED"] = "VALIDATED";
    OrderStatusEnum["MANUFACTURED"] = "MANUFACTURED";
    OrderStatusEnum["ANOMALY"] = "ANOMALY";
})(OrderStatusEnum || (OrderStatusEnum = {}));

var OriginTypeEnum;
(function (OriginTypeEnum) {
    OriginTypeEnum["FILE"] = "FILE";
    OriginTypeEnum["APPLICATION"] = "APPLICATION";
    OriginTypeEnum["MANUAL"] = "MANUAL";
})(OriginTypeEnum || (OriginTypeEnum = {}));

var PeriodTypeEnum;
(function (PeriodTypeEnum) {
    PeriodTypeEnum["MONTHLY"] = "MONTHLY";
    PeriodTypeEnum["YEARLY"] = "YEARLY";
})(PeriodTypeEnum || (PeriodTypeEnum = {}));

var ReceiverEmailAlertEnum;
(function (ReceiverEmailAlertEnum) {
    ReceiverEmailAlertEnum["PRO"] = "PRO";
    ReceiverEmailAlertEnum["PERSO"] = "PERSO";
})(ReceiverEmailAlertEnum || (ReceiverEmailAlertEnum = {}));

var RequestCardStatusEnum;
(function (RequestCardStatusEnum) {
    RequestCardStatusEnum["TO_VALIDATE"] = "TO_VALIDATE";
    RequestCardStatusEnum["DONE"] = "DONE";
    RequestCardStatusEnum["SHIPPED"] = "SHIPPED";
    RequestCardStatusEnum["PROCESSED"] = "PROCESSED";
    RequestCardStatusEnum["TO_BE_DONE"] = "TO_BE_DONE";
    RequestCardStatusEnum["CANCELLLED"] = "CANCELLLED";
})(RequestCardStatusEnum || (RequestCardStatusEnum = {}));

var RequestTypeEnum;
(function (RequestTypeEnum) {
    RequestTypeEnum["MANUFACTURING"] = "MANUFACTURING";
    RequestTypeEnum["CARD_REISSUE"] = "CARD_REISSUE";
    RequestTypeEnum["BLOCKING"] = "BLOCKING";
    RequestTypeEnum["UNBLOCKING"] = "UNBLOCKING";
    RequestTypeEnum["RENEWAL"] = "RENEWAL";
    RequestTypeEnum["PIN_CODE_REISSUE"] = "PIN_CODE_REISSUE";
})(RequestTypeEnum || (RequestTypeEnum = {}));

var StatutOperationEnum;
(function (StatutOperationEnum) {
    StatutOperationEnum["IN_PROGRESS"] = "En cours";
    StatutOperationEnum["CLOSED"] = "";
    StatutOperationEnum["REGULARIZATION"] = "R\u00E9gularisation";
    StatutOperationEnum["FAILURE"] = "Rejet\u00E9";
})(StatutOperationEnum || (StatutOperationEnum = {}));

var TransactionEnum;
(function (TransactionEnum) {
    TransactionEnum["C"] = "C";
    TransactionEnum["D"] = "D";
})(TransactionEnum || (TransactionEnum = {}));
var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum["LOADING"] = "LOADING";
    TransactionTypeEnum["CREDITNOTE"] = "CREDITNOTE";
    TransactionTypeEnum["INTERVENTION"] = "INTERVENTION";
})(TransactionTypeEnum || (TransactionTypeEnum = {}));
var TransactionMediumEnum;
(function (TransactionMediumEnum) {
    TransactionMediumEnum["PHYSICAL"] = "PHYSICAL";
    TransactionMediumEnum["DEMAT"] = "DEMAT";
})(TransactionMediumEnum || (TransactionMediumEnum = {}));

var TransactionReasonFailureEnum;
(function (TransactionReasonFailureEnum) {
    TransactionReasonFailureEnum["INACTIVE_CARDS"] = "INACTIVE_CARDS";
    TransactionReasonFailureEnum["MERCHANT_PROHIBITED"] = "MERCHANT_PROHIBITED";
    TransactionReasonFailureEnum["INSUFISANT_BALANCE"] = "INSUFISANT_BALANCE";
    TransactionReasonFailureEnum["DISTANCE_SELLING_PROHIBITED"] = "DISTANCE_SELLING_PROHIBITED";
    TransactionReasonFailureEnum["EXCEEDED_FUNDS"] = "EXCEEDED_FUNDS";
    TransactionReasonFailureEnum["WITHDRAWAL_PROHIBITED"] = "WITHDRAWAL_PROHIBITED";
    TransactionReasonFailureEnum["SUNDAY_AND_PUBLIC_HOLIDAY_PROHIBITED"] = "SUNDAY_AND_PUBLIC_HOLIDAY_PROHIBITED";
    TransactionReasonFailureEnum["OTHER"] = "OTHER";
})(TransactionReasonFailureEnum || (TransactionReasonFailureEnum = {}));

var TypeContactEnum;
(function (TypeContactEnum) {
    TypeContactEnum["EMAIL_PRO"] = "EMAIL_PRO";
    TypeContactEnum["EMAIL_PERSO"] = "EMAIL_PERSO";
    TypeContactEnum["CELL_PHONE_PRO"] = "CELL_PHONE_PRO";
    TypeContactEnum["CELL_PHONE_PERSO"] = "CELL_PHONE_PERSO";
    TypeContactEnum["PHONE_PRO"] = "PHONE_PRO";
})(TypeContactEnum || (TypeContactEnum = {}));

/**
 * Created by jouiniay on 25/02/2020.
 */
var ErrorTypeEnum;
(function (ErrorTypeEnum) {
    ErrorTypeEnum["ERROR"] = "ERROR";
    ErrorTypeEnum["WARNING"] = "WARNING";
})(ErrorTypeEnum || (ErrorTypeEnum = {}));

/**
 * Created by jouiniay on 25/02/2020.
 */
var ProcessingResultEnum;
(function (ProcessingResultEnum) {
    ProcessingResultEnum["OK"] = "OK";
    ProcessingResultEnum["KO"] = "KO";
})(ProcessingResultEnum || (ProcessingResultEnum = {}));

/**
 * Created by jouiniay on 25/02/2020.
 */
var ProcessingStatusEnum;
(function (ProcessingStatusEnum) {
    ProcessingStatusEnum["PENDING"] = "PENDING";
    ProcessingStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    ProcessingStatusEnum["COMPLETED"] = "COMPLETED";
})(ProcessingStatusEnum || (ProcessingStatusEnum = {}));

/**
 * Created by jouiniay on 25/02/2020.
 */
var ProcessingTypeEnum;
(function (ProcessingTypeEnum) {
    ProcessingTypeEnum["ORDER_REQUEST_PROCESSING"] = "ORDER_REQUEST_PROCESSING";
    ProcessingTypeEnum["CREATION_DEMANDES_EN_MASSE"] = "CREATION_DEMANDES_EN_MASSE";
})(ProcessingTypeEnum || (ProcessingTypeEnum = {}));

var CustomizationOrderSubType;
(function (CustomizationOrderSubType) {
    CustomizationOrderSubType["CARD"] = "CARD";
    CustomizationOrderSubType["VOUCHER"] = "VOUCHER";
    CustomizationOrderSubType["COVER"] = "COVER";
    CustomizationOrderSubType["START_BOOK"] = "START_BOOK";
    CustomizationOrderSubType["END_BOOK"] = "END_BOOK";
})(CustomizationOrderSubType || (CustomizationOrderSubType = {}));

var CustomizationOrderType;
(function (CustomizationOrderType) {
    CustomizationOrderType["BACKGROUND"] = "BACKGROUND";
    CustomizationOrderType["PERSONNALIZATION_DATA"] = "PERSONNALIZATION_DATA";
    CustomizationOrderType["CAMPAIGN"] = "CAMPAIGN";
})(CustomizationOrderType || (CustomizationOrderType = {}));

var ProcessingPriorityEnum;
(function (ProcessingPriorityEnum) {
    ProcessingPriorityEnum["ST"] = "ST";
    ProcessingPriorityEnum["SP"] = "SP";
    ProcessingPriorityEnum["UR"] = "UR";
})(ProcessingPriorityEnum || (ProcessingPriorityEnum = {}));

var MotifBlocageStatus;
(function (MotifBlocageStatus) {
    MotifBlocageStatus["LOSS"] = "LOSS";
    MotifBlocageStatus["ROB"] = "ROB";
    MotifBlocageStatus["FRAUD"] = "FRAUD";
    MotifBlocageStatus["NOT_ARRIVED_CARD"] = "NOT_ARRIVED_CARD";
    MotifBlocageStatus["WRONG_PIN_CODE"] = "WRONG_PIN_CODE";
    MotifBlocageStatus["DETERIORATED"] = "DETERIORATED";
    MotifBlocageStatus["TEMPORARY"] = "TEMPORARY";
    MotifBlocageStatus["MANUFACTORING_ERROR"] = "MANUFACTORING_ERROR";
    MotifBlocageStatus["NOT_ARRIVED_CODE"] = "NOT_ARRIVED_CODE";
    MotifBlocageStatus["LOST_PIN_CODE"] = "LOST_PIN_CODE";
    MotifBlocageStatus["ASKED_BY_CUSTOMER"] = "ASKED_BY_CUSTOMER";
    MotifBlocageStatus["DEFECTIVE"] = "DEFECTIVE";
})(MotifBlocageStatus || (MotifBlocageStatus = {}));

var OperationEnum;
(function (OperationEnum) {
    OperationEnum["EQUAL"] = "EQUAL";
    OperationEnum["LIKE"] = "LIKE";
    OperationEnum["IN"] = "IN";
    OperationEnum["DATE_EQUAL"] = "DATE_EQUAL";
    OperationEnum["DATE_AFTER"] = "DATE_AFTER";
    OperationEnum["DATE_BEFORE"] = "DATE_BEFORE";
})(OperationEnum || (OperationEnum = {}));

var ConjonctionEnum;
(function (ConjonctionEnum) {
    ConjonctionEnum["AND"] = "AND";
    ConjonctionEnum["OR"] = "OR";
})(ConjonctionEnum || (ConjonctionEnum = {}));

var StatutDemandeEnum;
(function (StatutDemandeEnum) {
    StatutDemandeEnum["ORDERED"] = "ORDERED";
    StatutDemandeEnum["APPROVED"] = "APPROVED";
    StatutDemandeEnum["TO_BE_APPROVED"] = "TO_BE_APPROVED";
    StatutDemandeEnum["TO_BE_APPROVED_N2"] = "TO_BE_APPROVED_N2";
    StatutDemandeEnum["REFUSED"] = "REFUSED";
    StatutDemandeEnum["MANUFACTURED"] = "MANUFACTURED";
    StatutDemandeEnum["SHIPPED"] = "SHIPPED";
    StatutDemandeEnum["INIT"] = "INIT";
})(StatutDemandeEnum || (StatutDemandeEnum = {}));

var FormatTitreEnum;
(function (FormatTitreEnum) {
    FormatTitreEnum["BOARD"] = "BOARD";
    FormatTitreEnum["BOOKLET"] = "BOOKLET";
    FormatTitreEnum["DEMAT"] = "DEMAT";
})(FormatTitreEnum || (FormatTitreEnum = {}));

var VintageEnum;
(function (VintageEnum) {
    VintageEnum["PREVIOUS_VINTAGE"] = "PREVIOUS_VINTAGE";
    VintageEnum["CURRENT_VINTAGE"] = "CURRENT_VINTAGE";
})(VintageEnum || (VintageEnum = {}));

var SimpleStatutDemandeEnum;
(function (SimpleStatutDemandeEnum) {
    SimpleStatutDemandeEnum["ORDERED"] = "ORDERED";
    SimpleStatutDemandeEnum["APPROVED"] = "APPROVED";
    SimpleStatutDemandeEnum["TO_BE_APPROVED"] = "TO_BE_APPROVED";
    SimpleStatutDemandeEnum["TO_BE_APPROVED_N2"] = "TO_BE_APPROVED_N2";
    SimpleStatutDemandeEnum["REFUSED"] = "REFUSED";
})(SimpleStatutDemandeEnum || (SimpleStatutDemandeEnum = {}));

var OrderRequestManagerTypeEnum;
(function (OrderRequestManagerTypeEnum) {
    OrderRequestManagerTypeEnum["CREATOR"] = "CREATOR";
    OrderRequestManagerTypeEnum["APPROVER"] = "APPROVER";
})(OrderRequestManagerTypeEnum || (OrderRequestManagerTypeEnum = {}));

var ChannelEnum;
(function (ChannelEnum) {
    ChannelEnum[ChannelEnum["FAQ"] = 0] = "FAQ";
    ChannelEnum[ChannelEnum["PUSH"] = 1] = "PUSH";
})(ChannelEnum || (ChannelEnum = {}));

let AuthGuardService = class AuthGuardService {
    constructor(authentificationService, router) {
        this.authentificationService = authentificationService;
        this.router = router;
    }
    canActivate(next, state) {
        if (this.authentificationService.isAuthenticated()) {
            return true;
        }
        sessionStorage.setItem(TARGET, next.url.join(''));
        this.router.navigate(['/authent']);
        return false;
    }
};
AuthGuardService.ɵfac = function AuthGuardService_Factory(t) { return new (t || AuthGuardService)(ɵngcc0.ɵɵinject(AuthentificationService), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
AuthGuardService.ctorParameters = () => [
    { type: AuthentificationService },
    { type: Router }
];
AuthGuardService.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuardService_Factory() { return new AuthGuardService(ɵɵinject(AuthentificationService), ɵɵinject(Router)); }, token: AuthGuardService, providedIn: "root" });

function groupElementsBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        }
        else {
            collection.push(item);
        }
    });
    return map;
}

function downloadCSV(data, headerList, headerLabels, filename = 'data') {
    const csvData = convertToCSV(data, headerList, headerLabels);
    const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {
        // if Safari open in new window to save file with random filename.
        dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
}
function convertToCSV(objArray, headerList, headerLabels) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';
    // tslint:disable-next-line: forin
    for (const index in headerLabels) {
        row += headerLabels[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
        let line = i + 1 + '';
        // tslint:disable-next-line: forin
        for (const index in headerList) {
            const head = headerList[index];
            line += ',' + array[i][head];
        }
        str += line + '\r\n';
    }
    return str;
}
function downloadPdf(response) {
    const contentDisposition = response.headers.get('content-disposition');
    const filename = contentDisposition
        .split(';')[1]
        .split('filename')[1]
        .split('=')[1]
        .trim();
    const blob = response.body;
    // IE doesn't allow using a blob object directly as link href
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
    }
    else {
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = data;
        link.download = filename;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
    }
}

const phoneRegex = /((\+)33|0|0033|(\+)33\s)[1-9](\d{2}){4}$/g;
const hasNumberRegex = /\d/;
const hasCapitalCaseRegex = /[A-Z]/;
const hasLowerCaseLetterRegex = /[a-z]/;
const hasSpecialCharacterRegex = /[!?/"_$µ()]/;

class Employee {
}
class EmployeeField {
}

function getEmployeeField() {
    const fields = sessionStorage.getItem(EMPLOYEE_ID).split('-');
    if (fields.length !== 3) {
        return undefined;
    }
    if (!fields[0] || fields[0] === ''
        || !fields[1] || fields[1] === ''
        || !fields[2] || fields[2] === '') {
        return undefined;
    }
    const employeeField = new EmployeeField();
    employeeField.issuerId = fields[0];
    employeeField.customerNumber = fields[1];
    employeeField.personalNumber = fields[2];
    return employeeField;
}

let HttpRequestInterceptor = class HttpRequestInterceptor {
    constructor(authentificationService, router) {
        this.authentificationService = authentificationService;
        this.router = router;
    }
    intercept(req, next) {
        return new Observable((observer) => {
            if (req.url.includes('/NIT')) {
                if (this.authentificationService.isAuthenticated()) {
                    req = req.clone({
                        setHeaders: {
                            Authorization: sessionStorage.getItem(ITEM_SCOPE) + ' ' + sessionStorage.getItem(ITEM_TOKEN)
                        }
                    });
                }
                else {
                    this.router.navigate(['/authent']);
                }
            }
            const subscription = next.handle(req).subscribe((event) => {
                if (event instanceof HttpResponse) {
                    observer.next(event);
                }
            }, (err) => {
                if (err.status === 401) {
                    sessionStorage.clear();
                    this.router.navigate(['/authent']);
                }
                observer.error(err);
            }, () => {
                observer.complete();
            });
            // remove request from queue when cancelled
            return () => {
                subscription.unsubscribe();
            };
        });
    }
};
HttpRequestInterceptor.ɵfac = function HttpRequestInterceptor_Factory(t) { return new (t || HttpRequestInterceptor)(ɵngcc0.ɵɵinject(AuthentificationService), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
HttpRequestInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HttpRequestInterceptor, factory: function (t) { return HttpRequestInterceptor.ɵfac(t); } });
HttpRequestInterceptor.ctorParameters = () => [
    { type: AuthentificationService },
    { type: Router }
];

let LangInterceptor = class LangInterceptor {
    constructor(translateService) {
        this.translateService = translateService;
    }
    intercept(request, next) {
        // add Accept-Language on every request
        const lang = this.translateService.currentLang;
        request = request.clone({
            setHeaders: {
                'Accept-Language': lang ? lang : 'fr'
            }
        });
        return next.handle(request);
    }
};
LangInterceptor.ɵfac = function LangInterceptor_Factory(t) { return new (t || LangInterceptor)(ɵngcc0.ɵɵinject(ɵngcc4.TranslateService)); };
LangInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LangInterceptor, factory: function (t) { return LangInterceptor.ɵfac(t); } });
LangInterceptor.ctorParameters = () => [
    { type: TranslateService }
];

class ApplicationMessage {
}

class ApplicationMessages {
}

class LegalNotices {
}

class TermAndCondition {
}

class TermsAndConditions {
}

class CardRequestReport {
}

class CardRequestReports {
}

class CardRequestsReportsAdditionalInformationModel {
}

class CardsReport {
}

class CardsReports {
}

class CustomerCardsAdditionalInformation {
}

class Customer {
}

class EmployeeCreationReport {
}

class EmployeeCreationReportsAdditionalInformation {
}

class TransactionsReports {
}

class TransactionsReport {
}

class OrderRequestReport {
}

class OrderRequestReports {
}

class OrderRequestReportsAdditionalInformation {
}

class EmployeeContactRequest {
}

class EmployeeContact {
}

class EmployeeCreate {
}

class EmployeeDeliveryMode {
}

class EmployeeProduct {
}

class EmployeeStructure {
}

class EmployeeSummary {
}

class EmployeeValueSetting {
}

class EmployeeVoucherValue {
}

class EmployeeResponse {
}

class Employees {
}

class Optin {
}

class Product {
}

/**
 * Created by jouiniay on 25/02/2020.
 */
class EmployeeOrderRequest {
}

/**
 * Created by jouiniay on 25/02/2020.
 */
class EmployeeError {
}

class EmployeeFileCreate {
}

class EmployeeFileCustomer {
}

class AccountAdditionalInformation {
}

class AccountResponse {
}

class BlockCardResponse {
}

class MotifsOperation {
}
class Motif {
}

class ReadCardInfoResponse {
}

class ReadCardRequestResponse {
}
class ReadCardRequest {
}

class ReasonParamBody {
}

class SubAccount {
}

class Transactions {
}
class Transaction {
}

class SendingEmails {
}

class OrderOrigin {
}

class Order {
}

class Orders {
}

class OrderAnomaly {
}

class OrderBilledService {
}

class OrderCustomization {
}

class OrderLine {
}

class OrderLineDetail {
}

class OrderLinesResponse {
}

class Personalisation {
}

class Billing {
}

class Processing {
}

class OrderRequestParamBody {
}

class Delivery {
}

class OrderRequestDetail {
}

class OrderRequestId {
}

class OrderRequestManager {
}

class OrderRequestsAdditionnalInformation {
}

class OrderRequestProcessingResponse {
}

class OrderRequestStatusUpdateProcessingBody {
}

class OrderFileCreate {
}

class OrderFileCustomer {
}

class Agreement {
}

class Contract {
}
class BankDetails {
}
class ContractContact {
}

class Participant {
}

class Participants {
}

class Categories {
}

class Category {
}

class CreditNoteCreate {
}

class LineCreditNote {
}

class Operation {
    constructor(conjunction, name, type, negation, value) {
        this.conjunction = conjunction;
        this.name = name;
        this.type = type;
        this.negation = negation;
        this.value = value;
    }
}

class Criterion {
    constructor(conjunction, operations) {
        this.conjunction = conjunction;
        this.operations = operations;
    }
}

class Criteria {
    constructor(criteria) {
        this.criteria = criteria;
    }
}

class AttachementPoint {
}

class CustomerInfo {
}

class DeliveryPointProductContact {
}

class DeliveryPointDepartement extends CustomerInfo {
}

class DeliveryPointProduct {
}

class DeliveryPoint {
}

class StructureSummary {
}

class StructureOrder {
}

class Address {
    getFormGroup() {
        return new FormGroup({
            building: new FormControl(undefined, []),
            locality: new FormControl(undefined, []),
            street: new FormControl(undefined, []),
            postalCode: new FormControl(undefined, []),
            city: new FormControl(undefined, []),
            country: new FormControl(undefined, [])
        });
    }
}

class Amount {
}

class CompanyModel {
}

class Contact {
}

class Page {
}

class Person {
}

class CreateTermsAndConditions {
}

class ReadTerm {
}

class ReadTerms {
}

class User {
}

class UserCreate {
}

class UserCriteria {
}

class UserActivation {
}

class UserActivationCreate {
}

class UserActivationRequest {
}

class UserActivationResponse {
}

class AccountBeneficiary {
}

class CheckingScratchAreaResponse {
}

class EmployeeTransactionAffiliate {
}

class EmployeeTransaction {
}

class EmployeeTransactions {
}

class Intervention {
}

class InterventionResponse {
}

class InterventionVoucher {
}

class Voucher {
}

class VoucherAccountResponse {
}

class VoucherAdditionalInformation {
}

class Vouchers {
}

/**
 * Created by jouiniay on 25/02/2020.
 */
class ProcessingError {
}

class ProcessingSummaries {
}

class ProcessingSummary {
}

let AffiliatesService = class AffiliatesService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'affiliate/') + env.versionApi + '/affiliates';
        this.product = env.codeProduit;
    }
    /**
     * Search for a participant using the affiliateNumber
     *
     * @param affiliateNumber the affiliateNumber to look for
     * @param compensatingId the compensatingId of the affiliate to look for
     */
    findAffiliatesByAffiliateNumber(affiliateNumber, compensatingId) {
        let params = new HttpParams();
        params = params.append('affiliateNumber', affiliateNumber);
        params = params.append('compensatingId', compensatingId);
        return this.http.get(this.url, { params });
    }
    /**
     * Search for a participant using its identity
     *
     * @param compensatingId the compensating id of the affiliate to look for
     * @param lastName the last name of the person
     * @param firstName the first name of the person
     * @param birthDate the date of birth of the person
     * @param postalCode the postal of the person
     */
    findAffiliatesByIdentity(compensatingId, lastName, firstName, birthDate, postalCode) {
        let params = new HttpParams();
        if (lastName) {
            params = params.append('lastName', lastName);
        }
        if (firstName) {
            params = params.append('firstName', firstName);
        }
        if (birthDate) {
            params = params.append('birthDate', birthDate);
        }
        if (postalCode) {
            params = params.append('postalCode', postalCode);
        }
        params = params.append('compensatingId', compensatingId);
        return this.http.get(this.url, { params });
    }
    /**
     * Create a new affiliate in the database
     *
     * @param affiliate the new affiliate that must be inserted in the database
     */
    createAffiliate(affiliate) {
        return this.http.post(this.url, affiliate);
    }
    /**
     * Get the contract after creating a new participant in the database
     *
     * @param affiliateId the affiliate id of the newly created participant
     */
    getContract(affiliateId) {
        return this.http.get(this.url + `/${affiliateId}/contracts/${this.product}`, { observe: 'response', responseType: 'blob' });
    }
};
AffiliatesService.ɵfac = function AffiliatesService_Factory(t) { return new (t || AffiliatesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
AffiliatesService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
AffiliatesService.ɵprov = ɵɵdefineInjectable({ factory: function AffiliatesService_Factory() { return new AffiliatesService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: AffiliatesService, providedIn: "root" });
AffiliatesService = __decorate([ __param(1, Inject('env'))
], AffiliatesService);

let ApplicationService = class ApplicationService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'application/') + env.versionApi;
    }
    readTermsAndConditions(applicationId, pProfileType, contentLanguage) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accept-Language': contentLanguage ? contentLanguage : 'fr'
            }),
            params: { profileType: pProfileType }
        };
        return this.http.get(this.url + '/applications/' + applicationId + '/termsAndConditions', httpOptions);
    }
    readLegalNotices(applicationId, contentLanguage) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accept-Language': contentLanguage ? contentLanguage : 'fr'
            })
        };
        return this.http.get(this.url + '/applications/' + applicationId + '/legalNotices/latest', httpOptions);
    }
    readQuestions(applicationId, query, pageSize, pageNumber) {
        let params = new HttpParams();
        if (query) {
            params = params.append('query', query);
        }
        if (pageSize) {
            params = params.append('pageSize', pageSize.toString());
        }
        if (pageNumber) {
            params = params.append('pageNumber', pageNumber.toString());
        }
        return this.http.get(this.url + '/applications/' + applicationId + '/questions', { params });
    }
    readQuestionsByThematics(applicationId, frequent, pageSize, pageNumber) {
        let params = new HttpParams();
        if (frequent !== null) {
            params = params.append('frequent', frequent ? 'true' : 'false');
        }
        if (pageSize) {
            params = params.append('pageSize', pageSize.toString());
        }
        if (pageNumber) {
            params = params.append('pageNumber', pageNumber.toString());
        }
        return this.http.get(this.url + '/applications/' + applicationId + '/thematicsQuestions', { params });
    }
    readResponses(questionId, channel) {
        let params = new HttpParams();
        if (channel) {
            params = params.append('channel', channel.toString());
        }
        return this.http.get(this.url + '/questions/' + questionId + '/responses', { params });
    }
};
ApplicationService.ɵfac = function ApplicationService_Factory(t) { return new (t || ApplicationService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
ApplicationService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
ApplicationService.ɵprov = ɵɵdefineInjectable({ factory: function ApplicationService_Factory() { return new ApplicationService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: ApplicationService, providedIn: "root" });
ApplicationService = __decorate([ __param(1, Inject('env'))
], ApplicationService);

let CardService = class CardService {
    constructor(http, env) {
        this.http = http;
        this.url = '/NIT/' + (env.localApi ? '' : 'card/') + env.versionApi + '/cards';
    }
    /**
     * Read card public data from number card :
     */
    get(cardNumber, expirationDate) {
        return this.http.get(this.url + '/' + cardNumber + '-' + expirationDate);
    }
};
CardService.ɵfac = function CardService_Factory(t) { return new (t || CardService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
CardService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
CardService.ɵprov = ɵɵdefineInjectable({ factory: function CardService_Factory() { return new CardService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: CardService, providedIn: "root" });
CardService = __decorate([ __param(1, Inject('env'))
], CardService);

let CharityService = class CharityService {
    constructor(http, env) {
        this.http = http;
        this.url = '/NIT/' + (env.localApi ? '' : 'charity/') + env.versionApi + '/charities';
    }
    /**
     * Provides a list of the associations for donation:
     */
    get(productId) {
        let params = new HttpParams();
        if (productId) {
            params = params.append('productId', productId);
        }
        return this.http.get(this.url, { params });
    }
};
CharityService.ɵfac = function CharityService_Factory(t) { return new (t || CharityService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
CharityService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
CharityService.ɵprov = ɵɵdefineInjectable({ factory: function CharityService_Factory() { return new CharityService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: CharityService, providedIn: "root" });
CharityService = __decorate([ __param(1, Inject('env'))
], CharityService);

let CustomerManagerService = class CustomerManagerService {
    constructor(http, env) {
        this.http = http;
        this.url = '/NIT/' + (env.localApi ? '' : 'customerManager/') + env.versionApi;
    }
    /**
     * Retrieve staffing categories available to a customer for a product
     */
    getManagers(customerId, applicationId, pageNumber, pageSize, profileId, sort, structureId) {
        let params = new HttpParams();
        if (applicationId) {
            params = params.append('applicationId', applicationId);
        }
        if (pageNumber) {
            params = params.append('pageNumber', pageNumber.toString());
        }
        if (pageSize) {
            params = params.append('pageSize', pageSize.toString());
        }
        if (profileId) {
            params = params.append('profileId', profileId);
        }
        if (sort) {
            params = params.append('sort', sort);
        }
        if (structureId) {
            params = params.append('structureId', structureId);
        }
        return this.http.get(this.url + '/customers/' + customerId + '/managers', { params });
    }
    getManager(managerId) {
        return this.http.get(this.url + '/managers/' + managerId);
    }
};
CustomerManagerService.ɵfac = function CustomerManagerService_Factory(t) { return new (t || CustomerManagerService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
CustomerManagerService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
CustomerManagerService.ɵprov = ɵɵdefineInjectable({ factory: function CustomerManagerService_Factory() { return new CustomerManagerService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: CustomerManagerService, providedIn: "root" });
CustomerManagerService = __decorate([ __param(1, Inject('env'))
], CustomerManagerService);

let CustomerProductService = class CustomerProductService {
    constructor(http, env) {
        this.http = http;
        this.url = '/NIT/' + (env.localApi ? '' : 'customerProduct/') + env.versionApi + '/customers';
    }
    /**
     * Retrieve staffing categories available to a customer for a product
     */
    getStaffingCategories(customerId, productId, isActive) {
        let params = new HttpParams();
        if (isActive) {
            params = params.append('isActive', isActive.toString());
        }
        return this.http.get(this.url + '/' + customerId + '/products/' + productId + '/staffingCategories', { params });
    }
    /**
     * Retrieve vouchers values available to a customer for a product
     */
    getValueSetting(customerId, productId, isActive) {
        let params = new HttpParams();
        if (isActive) {
            params = params.append('isActive', isActive.toString());
        }
        return this.http.get(this.url + '/' + customerId + '/products/' + productId + '/valueSettings', { params });
    }
    /**
     * Gets order periods of a customer
     */
    getPeriods(customerId, productId, isOpen) {
        let params = new HttpParams();
        if (isOpen) {
            params = params.append('isOpen', isOpen.toString());
        }
        return this.http.get(this.url + '/' + customerId + '/products/' + productId + '/orderPeriods', { params });
    }
};
CustomerProductService.ɵfac = function CustomerProductService_Factory(t) { return new (t || CustomerProductService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
CustomerProductService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
CustomerProductService.ɵprov = ɵɵdefineInjectable({ factory: function CustomerProductService_Factory() { return new CustomerProductService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: CustomerProductService, providedIn: "root" });
CustomerProductService = __decorate([ __param(1, Inject('env'))
], CustomerProductService);

let CustomerReportService = class CustomerReportService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'customerReport/') + env.versionApi;
    }
    readCardRequestsReports(pCustomerId, pProductId, pCardRequestType, pStatus, pToDate, pFromDate, pPeriodType) {
        return this.http.get(this.url + '/customers/' + pCustomerId +
            '/products/' + pProductId + '/cardRequestReports', {
            params: {
                cardRequestType: pCardRequestType, status: pStatus, toDate: dateFormat(pToDate),
                fromDate: dateFormat(pFromDate), periodType: pPeriodType
            }
        });
    }
    readCardReports(customerId, productId, pStatus) {
        return this.http.get(this.url + '/customers/' + customerId + '/products/' +
            productId + '/cardReports', {
            params: {
                status: pStatus
            }
        });
    }
    readTransactionReports(pCustomerId, pProductId, pDelivered, pVintage) {
        let params = new HttpParams();
        if (pDelivered !== undefined) {
            params = params.set('delivered', pDelivered);
        }
        if (pVintage !== undefined) {
            params = params.set('vintage', pVintage);
        }
        return this.http.get(this.url + '/customers/' + pCustomerId + '/products/' +
            pProductId + '/transactionReports', { params });
    }
    readEmployeeCreationReports(pCustomerId, pProductId, pStatus, pToDate, pFromDate, pPeriodType) {
        let params = new HttpParams();
        if (pStatus !== undefined) {
            params = params.set('status', pStatus);
        }
        if (pToDate !== undefined) {
            params = params.set('toDate', dateFormat(pToDate));
        }
        if (pFromDate !== undefined) {
            params = params.set('fromDate', dateFormat(pFromDate));
        }
        if (pPeriodType !== undefined) {
            params = params.set('periodType', pPeriodType);
        }
        return this.http.get(this.url + '/customers/' + pCustomerId + '/products/' +
            pProductId + '/employeeCreationReports', { params });
    }
    readManagerOrderRequestReports(customerId, managerId, periodId, statusList, productIdList, processingId, orderRequestManagerType) {
        let params = new HttpParams();
        params = params.append('periodId', periodId.toString());
        if (statusList) {
            params = params.append('status', statusList.toString());
        }
        if (productIdList) {
            params = params.append('productId', productIdList.toString());
        }
        if (processingId) {
            params = params.append('processingId', processingId.toString());
        }
        if (orderRequestManagerType) {
            params = params.append('orderRequestManagerType', orderRequestManagerType.toString());
        }
        return this.http.get(this.url + '/customers/' + customerId + '/managers/' + managerId + '/orderRequestReports', { params });
    }
};
CustomerReportService.ɵfac = function CustomerReportService_Factory(t) { return new (t || CustomerReportService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
CustomerReportService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
CustomerReportService.ɵprov = ɵɵdefineInjectable({ factory: function CustomerReportService_Factory() { return new CustomerReportService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: CustomerReportService, providedIn: "root" });
CustomerReportService = __decorate([ __param(1, Inject('env'))
], CustomerReportService);

let CustomerService = class CustomerService {
    constructor(http, env) {
        this.http = http;
        this.url = '/NIT/' + (env.localApi ? '' : 'customer/') + env.versionApi + '/customers';
    }
    /**
     * Retrieve cards for a customer
     */
    getCards(customerId, delivered, pageNumber, pageSize, status, structureId) {
        let params = new HttpParams();
        if (delivered) {
            params = params.append('delivered', delivered.toString());
        }
        if (pageNumber) {
            params = params.append('pageNumber', pageNumber.toString());
        }
        if (pageSize) {
            params = params.append('pageSize', pageSize.toString());
        }
        if (status) {
            for (const stat of status) {
                params = params.append('status', stat);
            }
        }
        if (structureId) {
            params = params.append('structureId', structureId.toString());
        }
        return this.http.get(this.url + '/cards' + customerId + '/', { params });
    }
    /**
     * Retrieve delivery points for a customer
     */
    getDeliveryPoints(customerId, address, includeDepartments, isActive, name, pageNumber, pageSize, postalCode, sort, structureCode, structureCodeSearchType, structureId) {
        let params = new HttpParams();
        if (address) {
            params = params.append('address', address);
        }
        if (includeDepartments) {
            params = params.append('includeDepartments', includeDepartments.toString());
        }
        if (isActive) {
            params = params.append('isActive', isActive.toString());
        }
        if (name) {
            params = params.append('name', name.toString());
        }
        if (pageNumber) {
            params = params.append('pageNumber', pageNumber.toString());
        }
        if (pageSize) {
            params = params.append('pageSize', pageSize.toString());
        }
        if (postalCode) {
            params = params.append('postalCode', postalCode);
        }
        if (sort) {
            params = params.append('sort', sort);
        }
        if (structureCode) {
            params = params.append('structureCode', structureCode);
        }
        if (structureCodeSearchType) {
            params = params.append('structureCodeSearchType', structureCodeSearchType);
        }
        if (structureId) {
            params = params.append('structureId', structureId.toString());
        }
        return this.http.get(this.url + '/' + customerId + '/deliveryPoints', { params });
    }
};
CustomerService.ɵfac = function CustomerService_Factory(t) { return new (t || CustomerService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
CustomerService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
CustomerService.ɵprov = ɵɵdefineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: CustomerService, providedIn: "root" });
CustomerService = __decorate([ __param(1, Inject('env'))
], CustomerService);

let EmployeeAffiliatesService = class EmployeeAffiliatesService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'employeeAffiliate/') + env.versionApi + '/employees';
        this.product = env.codeProduit;
    }
    /**
     * Get the list of participants of a specific employee for a specific product
     *
     * @param employeeId the id of the employee to retrieve the list of participant from
     * @param used a boolean to retrieve the list of currently used participant or the complete history
     */
    getParticipants(employeeId, used) {
        let params = new HttpParams();
        params = params.append('used', String(used));
        return this.http.get(this.url +
            `/${employeeId}/products/${this.product}/affiliates`, { params });
    }
    /**
     * Link a participant to an affiliate
     *
     * @param employeeId the employee on which to link an affiliate
     * @param affiliateNumber the id of the affiliate to link to the employee
     * @param compensatingId the compensating id of the affiliate to link to the employee
     */
    addParticipant(employeeId, affiliateNumber, compensatingId) {
        const body = {
            number: affiliateNumber,
            compensatingId
        };
        return this.http.post(this.url +
            `/${employeeId}/products/${this.product}/affiliates`, body);
    }
    /**
     * Delete the link between a participant and an affiliate
     *
     * @param employeeId the employee on which to remove the link to an affiliate
     * @param affiliateId the id of the participant to delete the link with
     */
    deleteParticipant(employeeId, affiliateId) {
        return this.http.delete(this.url + `/${employeeId}/products/${this.product}/affiliates/${affiliateId}`);
    }
};
EmployeeAffiliatesService.ɵfac = function EmployeeAffiliatesService_Factory(t) { return new (t || EmployeeAffiliatesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
EmployeeAffiliatesService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
EmployeeAffiliatesService.ɵprov = ɵɵdefineInjectable({ factory: function EmployeeAffiliatesService_Factory() { return new EmployeeAffiliatesService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: EmployeeAffiliatesService, providedIn: "root" });
EmployeeAffiliatesService = __decorate([ __param(1, Inject('env'))
], EmployeeAffiliatesService);

let EmployeesService = class EmployeesService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'employee/') + env.versionApi + '/employees/';
        this.urlCustomers = '/NIT/' + (env.localApi ? '' : 'employee/') + env.versionApi + '/customers/';
        this.product = env.codeProduit;
    }
    /**
     * @deprecated
     */
    find(pCardNumber, pExpirationDate) {
        return this.http.get(this.url, { params: { cardNumber: pCardNumber, expirationDate: pExpirationDate } });
    }
    readEmployeeByCriteria(employeeCriteria) {
        let params = new HttpParams();
        if (employeeCriteria.cardNumber) {
            params = params.append('cardNumber', employeeCriteria.cardNumber);
        }
        if (employeeCriteria.expirationDate) {
            params = params.append('expirationDate', employeeCriteria.expirationDate);
        }
        if (employeeCriteria.employeePersonalCode) {
            params = params.append('employeePersonalCode', employeeCriteria.employeePersonalCode);
        }
        if (employeeCriteria.productId) {
            params = params.append('productId', employeeCriteria.productId);
        }
        if (employeeCriteria.birthDate) {
            params = params.append('birthDate', dateFormat(employeeCriteria.birthDate));
        }
        return this.http.get(this.url, { params });
    }
    findById(employeeId) {
        return this.http.get(this.url + employeeId);
    }
    fetchOptions(employeeId) {
        return this.http.get(this.url + employeeId + '/products/' + this.product + '/options');
    }
    updateContact(employeeId, contactId, value) {
        return this.http.put(this.url + employeeId + '/contacts/' + contactId, { value });
    }
    updateOptions(employeeId, optionsId, isSubscribed) {
        return this.http.put(this.url + employeeId + '/products/' + this.product + '/options/' + optionsId, { isSubscribed });
    }
    patch(employeeId, employee) {
        return this.http.patch(this.url + employeeId, employee);
    }
    patchProductForEmployee(employeeId, product) {
        return this.http.patch(this.url + employeeId + '/products/' + this.product, product);
    }
    /**
     * 	Retrieve employees for a customer
     */
    readEmployees(customerId, sort, productId, deliveryModeType, deliveryModeDestination, productStatus, cardStatus, q, pageSize, pageNumber, include) {
        let params = new HttpParams();
        if (sort) {
            params = params.append('sort', sort);
        }
        if (productId) {
            params = params.append('productId', productId);
        }
        if (deliveryModeType) {
            params = params.append('deliveryModeType', deliveryModeType);
        }
        if (deliveryModeDestination) {
            params = params.append('deliveryModeDestination', deliveryModeDestination);
        }
        if (productStatus) {
            params = params.append('productStatus', productStatus);
        }
        if (cardStatus) {
            params = params.append('cardStatus', cardStatus);
        }
        if (q) {
            params = params.append('q', q);
        }
        if (pageSize) {
            params = params.append('pageSize', pageSize.toString());
        }
        if (pageNumber) {
            params = params.append('pageNumber', pageNumber.toString());
        }
        if (include) {
            params = params.append('include', include);
        }
        return this.http.get(this.urlCustomers + customerId + '/employees', { params });
    }
    createEmployee(customerId, employee) {
        return this.http.post(this.urlCustomers + customerId + '/employees', employee);
    }
    deleteProductForEmployee(employeeId, productId) {
        return this.http.delete(this.url + employeeId + '/products/' + productId);
    }
    createEmployeeContactRequests(employeeId, productId, contactRequest) {
        return this.http.post(this.url + employeeId + '/products/' + productId + '/contactRequests', contactRequest);
    }
    addProductForEmployee(employeeId, employeeAddProductctBody) {
        return this.http.post(this.url + employeeId + '/products', employeeAddProductctBody);
    }
    createPaymentIncident(employeeId, productId, paymentIncident) {
        return this.http.post(this.url + employeeId + '/products/' + productId + '/paymentIncidents', paymentIncident);
    }
    updateEmployeeOptin(employeeId, optinsId, agreement) {
        return this.http.put(this.url + employeeId + '/optins/' + optinsId, { agreement });
    }
    uploadEmployeeFile(customerId, productId, body) {
        return this.http.post(this.urlCustomers + customerId + '/products/' + productId + '/employees', body);
    }
};
EmployeesService.ɵfac = function EmployeesService_Factory(t) { return new (t || EmployeesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
EmployeesService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
EmployeesService.ɵprov = ɵɵdefineInjectable({ factory: function EmployeesService_Factory() { return new EmployeesService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: EmployeesService, providedIn: "root" });
EmployeesService = __decorate([ __param(1, Inject('env'))
], EmployeesService);

let HoldersService = class HoldersService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.holders = '/holders/';
        this.url = '/NIT/' + (env.localApi ? '' : 'holder/') + env.versionApi;
    }
    findAllTransactions(idHolder, fromDate, toDate, sort, direction) {
        let params = new HttpParams();
        if (fromDate) {
            params = params.append('fromDate', dateFormat(fromDate));
        }
        if (toDate) {
            params = params.append('toDate', dateFormat(toDate));
        }
        if (sort && direction) {
            params = params.append('sort', sort + ',' + direction);
        }
        return this.http.get(this.url + this.holders + idHolder + '/accounts/main/transactions', { params });
    }
    readCardRequests(idHolder, fromDate, toDate, type, status) {
        let params = new HttpParams();
        if (fromDate) {
            params = params.append('fromDate', dateFormat(fromDate));
        }
        if (toDate) {
            params = params.append('toDate', dateFormat(toDate));
        }
        if (type) {
            params = params.append('type', type);
        }
        if (status) {
            params = params.append('status', status);
        }
        return this.http.get(this.url + this.holders + idHolder + '/cards/main/cardRequests', { params });
    }
    findAccounts(holderId) {
        return this.http.get(this.url + this.holders + holderId + '/' + 'accounts');
    }
    findCard(holderId) {
        return this.http.get(this.url + this.holders + holderId + '/' + 'cards/main');
    }
    getRequestReasons(origin, type) {
        return this.http.get(this.url + '/requestReasons?' + 'origin=' + origin + '&requestType=' + type);
    }
    blockCard(holderId, reasonId, contentLanguage, cardReissueAutomatic, address, sendingEmails) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accept-Language': contentLanguage ? contentLanguage : 'fr'
            }),
        };
        return this.http.post(this.url + this.holders + holderId + '/' + 'cards/main/cardBlockingRequests', { reasonId, cardReissueAutomatic, address, sendingEmails }, httpOptions);
    }
    unBlockCard(holderId) {
        return this.http.post(this.url + this.holders + holderId + '/' + 'cards/main/cardUnblockingRequests', {});
    }
    reissuePinCode(holderId, reasonId, address) {
        return this.http.post(this.url + this.holders + holderId + '/' + 'cards/main/pinCodeReissueRequests', { reasonId, address });
    }
    // Reissue a card from a functional reference of the cardholder
    reissueCard(holderId, reasonId, address) {
        return this.http.post(this.url + this.holders + holderId + '/' + 'cards/main/cardReissueRequests', { reasonId, address });
    }
};
HoldersService.ɵfac = function HoldersService_Factory(t) { return new (t || HoldersService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
HoldersService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
HoldersService.ɵprov = ɵɵdefineInjectable({ factory: function HoldersService_Factory() { return new HoldersService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: HoldersService, providedIn: "root" });
HoldersService = __decorate([ __param(1, Inject('env'))
], HoldersService);

let IndividualEmployerService = class IndividualEmployerService {
    constructor(http, env) {
        this.http = http;
        this.url = '/NIT/' + (env.localApi ? '' : 'individualEmployer/') + env.versionApi + '/individualEmployers';
    }
};
IndividualEmployerService.ɵfac = function IndividualEmployerService_Factory(t) { return new (t || IndividualEmployerService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
IndividualEmployerService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
IndividualEmployerService.ɵprov = ɵɵdefineInjectable({ factory: function IndividualEmployerService_Factory() { return new IndividualEmployerService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: IndividualEmployerService, providedIn: "root" });
IndividualEmployerService = __decorate([ __param(1, Inject('env'))
], IndividualEmployerService);

let MerchantService = class MerchantService {
    constructor(http, env) {
        this.http = http;
        this.url = '/NIT/' + (env.localApi ? '' : 'merchant/') + env.versionApi + '/merchants';
    }
    /**
     * Retrieve merchants :
     */
    find(city, postalCode, categoryId, sort, name) {
        let params = new HttpParams();
        if (city) {
            params = params.append('city', city.toString());
        }
        if (postalCode) {
            params = params.append('postalCode', postalCode.toString());
        }
        if (categoryId) {
            params = params.append('categoryId', categoryId.toString());
        }
        if (sort) {
            params = params.append('sort', sort);
        }
        if (name) {
            params = params.append('name', name);
        }
        return this.http.get(this.url, { params });
    }
    /**
     * Retrieve merchants :
     */
    findByGPS(longitude, latitude, perimeter, sort) {
        let params = new HttpParams();
        if (longitude) {
            params = params.append('longitude', longitude.toString());
        }
        if (latitude) {
            params = params.append('latitude', latitude.toString());
        }
        if (perimeter) {
            params = params.append('perimeter', perimeter.toString());
        }
        if (sort) {
            params = params.append('sort', sort);
        }
        return this.http.get(this.url, { params });
    }
    /**
     * Retrieve data from a merchant :
     */
    getById(merchantId, longitude, latitude) {
        let params = new HttpParams();
        if (longitude) {
            params = params.append('longitude', longitude.toString());
        }
        if (latitude) {
            params = params.append('latitude', latitude.toString());
        }
        return this.http.get(this.url + '/' + merchantId, { params });
    }
};
MerchantService.ɵfac = function MerchantService_Factory(t) { return new (t || MerchantService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
MerchantService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
MerchantService.ɵprov = ɵɵdefineInjectable({ factory: function MerchantService_Factory() { return new MerchantService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: MerchantService, providedIn: "root" });
MerchantService = __decorate([ __param(1, Inject('env'))
], MerchantService);

let OrderService = class OrderService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'order/') + env.versionApi;
    }
    readOrders(customerId, pProductId, pToDate, pFromDate, pBackOfficeNumber, pDistributionNumber) {
        let params = new HttpParams();
        params = params.append('productId', pProductId);
        if (pToDate) {
            params = params.append('toDate', dateFormat(pToDate));
        }
        if (pFromDate) {
            params = params.append('fromDate', dateFormat(pFromDate));
        }
        if (pBackOfficeNumber) {
            params = params.append('backOfficeNumber', pBackOfficeNumber);
        }
        if (pDistributionNumber) {
            params = params.append('distributionNumber', pDistributionNumber);
        }
        return this.http.get(this.url + '/customers/' + customerId + '/orders', { params });
    }
    createOrderRequestProcessing(customerId, productId, body) {
        return this.http.post(this.url + '/customers/' + customerId + '/products/' + productId + '/orderRequestProcessings', body);
    }
    readOrderRequestProcessing(userId, processingId) {
        return this.http.get(this.url + '/users/' + userId + '/orderRequestProcessings/' + processingId);
    }
    readOrder(orderId) {
        return this.http.get(this.url + '/orders/' + orderId);
    }
    readOrderLines(orderId, pageNumber, pageSize, sort, q) {
        let params = new HttpParams();
        if (pageNumber) {
            params = params.append('pageNumber', pageNumber.toString());
        }
        if (pageSize) {
            params = params.append('pageSize', pageSize.toString());
        }
        if (sort) {
            params = params.append('sort', sort);
        }
        if (q) {
            params = params.append('q', q);
        }
        return this.http.get(this.url + '/orders/' + orderId + '/lines', { params });
    }
    readOrderRequests(customerId, managerId, pProductId, periodId, status, employeeId, pageSize, pageNumber, sort) {
        let params = new HttpParams();
        params = params.append('productId', pProductId);
        if (periodId) {
            params = params.append('periodId', periodId.toString());
        }
        if (status) {
            params = params.append('status', status);
        }
        if (employeeId) {
            params = params.append('employeeId', employeeId);
        }
        if (pageNumber) {
            params = params.append('pageNumber', pageNumber.toString());
        }
        if (pageSize) {
            params = params.append('pageSize', pageSize.toString());
        }
        if (sort) {
            params = params.append('sort', sort);
        }
        return this.http.get(this.url + '/customers/' + customerId + '/managers/' + managerId + '/orderRequests', { params });
    }
    uploadOrderFile(customerId, productId, body) {
        return this.http.post(this.url + '/customers/' + customerId + '/products/' + productId + '/orderFiles', body);
    }
    createOrderRequestStatusUpdateProcessing(customerId, productId, body) {
        return this.http.post(this.url + '/customers/' + customerId + '/products/' + productId + '/orderRequestStateProcessings', body);
    }
};
OrderService.ɵfac = function OrderService_Factory(t) { return new (t || OrderService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
OrderService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
OrderService.ɵprov = ɵɵdefineInjectable({ factory: function OrderService_Factory() { return new OrderService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: OrderService, providedIn: "root" });
OrderService = __decorate([ __param(1, Inject('env'))
], OrderService);

let ProductsService = class ProductsService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.urlService = '/networks/default/services/BENEFICIARY';
        this.url = '/NIT/' + (env.localApi ? '' : 'product/') + env.versionApi + '/products/' + env.codeProduit;
    }
    getPhoneNumber() {
        return this.http.get(this.url + this.urlService);
    }
    postContactForm(form) {
        return this.http.post(this.url + this.urlService + '/contactRequests', form);
    }
    getCategories(sortType, directionType) {
        let params = new HttpParams();
        if (sortType && directionType) {
            params = params.append('sort', sortType + ',' + directionType);
        }
        return this.http.get(this.url + '/categories', { params });
    }
    getServiceContacts(network, service) {
        return this.http.get(this.url + '/networks/' + network + '/services/' + service);
    }
    createContactRequestIssuer(network, service, form) {
        return this.http.post(this.url + '/networks/' + network + '/services/' + service + '/contactRequests', form);
    }
};
ProductsService.ɵfac = function ProductsService_Factory(t) { return new (t || ProductsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
ProductsService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
ProductsService.ɵprov = ɵɵdefineInjectable({ factory: function ProductsService_Factory() { return new ProductsService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: ProductsService, providedIn: "root" });
ProductsService = __decorate([ __param(1, Inject('env'))
], ProductsService);

let ReferentialService = class ReferentialService {
    constructor(http, env) {
        this.http = http;
        this.url = '/NIT/' + (env.localApi ? '' : 'referential/') + env.versionApi + '/cities';
    }
    /**
     * Retrieve cities
     */
    getCities(city, postalCode, sort) {
        let params = new HttpParams();
        if (city) {
            params = params.append('city', city);
        }
        if (postalCode) {
            params = params.append('postalCode', postalCode);
        }
        if (sort) {
            params = params.append('sort', sort);
        }
        return this.http.get(this.url, { params });
    }
};
ReferentialService.ɵfac = function ReferentialService_Factory(t) { return new (t || ReferentialService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
ReferentialService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
ReferentialService.ɵprov = ɵɵdefineInjectable({ factory: function ReferentialService_Factory() { return new ReferentialService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: ReferentialService, providedIn: "root" });
ReferentialService = __decorate([ __param(1, Inject('env'))
], ReferentialService);

let StructureService = class StructureService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/structure/' + env.versionApi;
    }
    findDeliveryPoint(deliveryPointId) {
        return this.http.get(this.url + '/deliveryPoints/' + deliveryPointId);
    }
};
StructureService.ɵfac = function StructureService_Factory(t) { return new (t || StructureService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
StructureService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
StructureService.ɵprov = ɵɵdefineInjectable({ factory: function StructureService_Factory() { return new StructureService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: StructureService, providedIn: "root" });
StructureService = __decorate([ __param(1, Inject('env'))
], StructureService);

let UserIDPService = class UserIDPService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'userIDP/') + env.versionApi + '/';
    }
    activateUser(pUserActivationId, pUserActivation) {
        return this.http.patch(this.url + 'userActivations/' + pUserActivationId, pUserActivation);
    }
    sendActivationAccount(userActivationRequest) {
        return this.http.post(this.url + 'userActivations', userActivationRequest);
    }
    createUserProfiles(userId, createUserProfilesRequest) {
        return this.http.post(this.url + 'users/' + userId + '/profiles', createUserProfilesRequest);
    }
};
UserIDPService.ɵfac = function UserIDPService_Factory(t) { return new (t || UserIDPService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
UserIDPService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
UserIDPService.ɵprov = ɵɵdefineInjectable({ factory: function UserIDPService_Factory() { return new UserIDPService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: UserIDPService, providedIn: "root" });
UserIDPService = __decorate([ __param(1, Inject('env'))
], UserIDPService);

const ALREADY_USED = 'ALREADY_USED';
const READY_TO_USE = 'READY_TO_USE';
const STATUS = 'status';
let VoucherService = class VoucherService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'voucher/') + env.versionApi;
        this.product = env.codeProduit;
    }
    getVouchers(employeeId, status, sortType, directionType) {
        let params = '';
        params = '?';
        params = params + STATUS + '=' + status;
        if (sortType && directionType) {
            params = params + '&sort=' + sortType + '%2C' + directionType;
        }
        return this.http.get(this.url + `/employees/${employeeId}/products/${this.product}/vouchers` + params);
    }
    getAccounts(employeeId) {
        return this.http.get(this.url + `/employees/${employeeId}/products/${this.product}/accounts`);
    }
    postCheckingScratchArea(code, voucherNumber, issuerId) {
        const params = { code, issuerId, productId: this.product, number: voucherNumber };
        return this.http.post(this.url + '/voucherScratchOffChecks', params);
    }
    getTransactions(employeeId, fromDate, toDate, productCategoryId, name) {
        let params = new HttpParams();
        if (fromDate) {
            params = params.append('fromDate', fromDate);
        }
        if (toDate) {
            params = params.append('toDate', toDate);
        }
        if (productCategoryId != null && typeof productCategoryId !== 'undefined') {
            params = params.append('productCategoryId', productCategoryId.toString());
        }
        if (name) {
            params = params.append('name', name);
        }
        return this.http.get(this.url + `/employees/${employeeId}/products/${this.product}/transactions`, {
            params
        });
    }
    postIntervention(employeeId, form) {
        return this.http.post(this.url + `/employees/${employeeId}/products/${this.product}/interventions`, form);
    }
    readVoucherRights(employeeId, productId) {
        return this.http.get(this.url + '/employees/' + employeeId + '/products/' + productId + '/voucherRights');
    }
    readAllocationRates(employeeId, productId) {
        return this.http.get(this.url + '/employees/' + employeeId + '/products/' + productId + '/allocationRates');
    }
    updateAllocationRate(employeeId, productId, allocationRateId, active) {
        const body = {
            active
        };
        return this.http.patch(this.url + '/employees/' + employeeId + '/products/' + productId + '/allocationRates/' + allocationRateId, body);
    }
    /**
     * Download the Payment Certificate of intervention
     *
     * @param interventionId Identifiant of intervention
     */
    readPaymentCertificate(interventionId) {
        return this.http.get(this.url + `/interventions/${interventionId}/paymentCertificates/latest`, { observe: 'response', responseType: 'blob' });
    }
    readRematerializationCampaignsActives(employeeId, login, applicationId) {
        const httpOptions = {
            headers: new HttpHeaders()
        };
        if (login) {
            httpOptions.headers.set('sub', login);
        }
        if (applicationId) {
            httpOptions.headers.set('appname', applicationId);
        }
        return this.http.get(this.url + '/employees/' + employeeId + '/products/' + this.product + '/rematerializationCampaigns', httpOptions);
    }
    createRematerializationRequest(employeeId, body, login, applicationId) {
        const httpOptions = {
            headers: new HttpHeaders()
        };
        if (login) {
            httpOptions.headers.set('sub', login);
        }
        if (applicationId) {
            httpOptions.headers.set('appname', applicationId);
        }
        return this.http.
            post(this.url + '/employees/' + employeeId + '/products/' + this.product + '/rematerializationRequests', body, httpOptions);
    }
};
VoucherService.ɵfac = function VoucherService_Factory(t) { return new (t || VoucherService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
VoucherService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
VoucherService.ɵprov = ɵɵdefineInjectable({ factory: function VoucherService_Factory() { return new VoucherService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: VoucherService, providedIn: "root" });
VoucherService = __decorate([ __param(1, Inject('env'))
], VoucherService);

let ProcessingService = class ProcessingService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.url = '/NIT/' + (env.localApi ? '' : 'processing/') + env.versionApi;
    }
    readProcessings(userId) {
        return this.http.get(this.url + '/users/' + userId + '/processings');
    }
};
ProcessingService.ɵfac = function ProcessingService_Factory(t) { return new (t || ProcessingService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
ProcessingService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
ProcessingService.ɵprov = ɵɵdefineInjectable({ factory: function ProcessingService_Factory() { return new ProcessingService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: ProcessingService, providedIn: "root" });
ProcessingService = __decorate([ __param(1, Inject('env'))
], ProcessingService);

let CreditNoteService = class CreditNoteService {
    constructor(http, env) {
        this.http = http;
        this.url = '/NIT/' + (env.localApi ? '' : 'creditNote/') + env.versionApi + '/customers';
    }
    createCreditNote(customerId, body) {
        return this.http.post(this.url + '/' + customerId + '/accountCreditNotes', body);
    }
};
CreditNoteService.ɵfac = function CreditNoteService_Factory(t) { return new (t || CreditNoteService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
CreditNoteService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
CreditNoteService.ɵprov = ɵɵdefineInjectable({ factory: function CreditNoteService_Factory() { return new CreditNoteService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: CreditNoteService, providedIn: "root" });
CreditNoteService = __decorate([ __param(1, Inject('env'))
], CreditNoteService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DebounceClickDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line
                selector: '[debounceClick]'
            }]
    }], function () { return []; }, { debounceTime: [{
            type: Input
        }], debounceClick: [{
            type: Output
        }], clickEvent: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HiddenOnProdDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line
                selector: '[hiddenOnProd]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardNumberPipe, [{
        type: Pipe,
        args: [{ name: 'cardNumber' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthentificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: UserService }, { type: ɵngcc2.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TokenComponent, [{
        type: Component,
        args: [{
                selector: 'nit-token-response',
                template: ''
            }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: AuthentificationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthentificationComponent, [{
        type: Component,
        args: [{
                /* tslint:disable-next-line */
                selector: 'app-token',
                template: "<div class=\"card\">\r\n  <div class=\"card-header\">\r\n    <h2>Authentification</h2>\r\n  </div>\r\n  <div class=\"card-body\">\r\n    <div>\r\n      <label>Redirection automatique vers la page de connexion</label>\r\n    </div>\r\n    <br />\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: AuthentificationService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DeconnexionComponent, [{
        type: Component,
        args: [{
                selector: 'nit-deconnexion',
                template: "<p>Deconnexion</p>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: AuthentificationService }, { type: ɵngcc2.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CreditCardComponent, [{
        type: Component,
        args: [{
                selector: 'nit-credit-card',
                template: "<div class=\"container d-flex justify-content-center\">\r\n    <div class=\"card\" [style.backgroundImage]=\"'url('+ backGround +')'\">\r\n        <div class=\"logo d-flex justify-content-between\">\r\n            <img class=\"logo1\" src=\"{{ logo1 }}\"/>\r\n            <img class=\"logo2\" src=\"{{ logo2 }}\"/>\r\n            <img class=\"logo3\" src=\"{{ logo3 }}\"/>\r\n        </div>\r\n\r\n        <div class=\"triangle\"></div>\r\n\r\n        <img class=\"puce\" src=\"{{ puce }}\"/>\r\n        <img class=\"sansContact\" src=\"{{ sansContact }}\"/>\r\n        \r\n        <div class=\"name\">\r\n            {{namePorteur}}\r\n        </div>\r\n        <div class=\"expiration d-flex justify-content-start\">\r\n            <div class=\"labelExpire\">EXPIRE <br>A FIN</div>\r\n            <div class=\"dateExpire\">{{expirationDate}}</div>    \r\n        </div>\r\n        <div class=\"number\">\r\n            {{cardNumber}}\r\n        </div>    \r\n        <div>\r\n            <img class=\"visa\" src=\"{{logoTypeCard}}\"/>\r\n        </div>   \r\n    </div>\r\n</div>",
                styles: [".card{width:300px;height:200px;border-radius:12px;color:#fff}.name{position:absolute;top:80%;left:50px}.expiration{position:absolute;top:67%;left:50%}.number{font-family:Halter;letter-spacing:2px;position:absolute;top:55%;left:50px}.puce{position:absolute;top:30%;left:50px;width:40px}.sansContact{position:absolute;top:27%;left:110px;width:40px}.visa{width:50px;position:absolute;right:5%;bottom:5%}.logo{width:100%;padding-left:50px;padding-right:50px;padding-top:6px}.logo1,.logo2,.logo3{width:30px}.labelExpire{font-size:7px;padding-right:8px}.triangle{position:absolute;width:0;height:0;top:60%;left:10px;border-top:30px solid transparent;border-bottom:30px solid transparent;border-right:20px solid #fff}"]
            }]
    }], function () { return []; }, { backGround: [{
            type: Input
        }], logoTypeCard: [{
            type: Input
        }], namePorteur: [{
            type: Input
        }], expirationDate: [{
            type: Input
        }], cardNumber: [{
            type: Input
        }], puce: [{
            type: Input
        }], sansContact: [{
            type: Input
        }], logo1: [{
            type: Input
        }], logo2: [{
            type: Input
        }], logo3: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpinnerButtonComponent, [{
        type: Component,
        args: [{
                selector: 'nit-spinner-button',
                template: "\r\n<button class=\"position-relative\"\r\n        debounceClick\r\n        (debounceClick)=\"submit()\"\r\n        [ngClass]=\"css\"\r\n        type=\"button\"\r\n        [disabled]=\"disabled\">\r\n  {{label}}\r\n  <div class=\"spinner-loader\" *ngIf=\"isLoading\">\r\n    <div class=\"spinner-border spinner-border-sm\" role=\"status\">\r\n      <span class=\"sr-only\"></span>\r\n    </div>\r\n  </div>\r\n</button>\r\n",
                styles: [".spinner-loader{position:absolute;right:10%;top:20%}"]
            }]
    }], function () { return []; }, { clicked: [{
            type: Output
        }], label: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], css: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormDiagnosticComponent, [{
        type: Component,
        args: [{
                selector: 'nit-form-diagnostic',
                template: "<button type=\"button\" class=\"btn btn-danger\" appHiddenOnProd (click)=\"diagnostic()\">\r\n  Diagnostic\r\n</button>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { form: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{
                selector: 'nit-pagination',
                template: "<nav #pagination aria-label=\"pagination\">\r\n  <ul class=\"pagination justify-content-center\">\r\n    <li class=\"page-item\">\r\n      <a class=\"page-link\" aria-label=\"Pr\u00E9c\u00E9dent\" (click)=\"goTo(+pageNumber - 1)\">\r\n        <span aria-hidden=\"true\">&laquo;</span>\r\n        <span class=\"sr-only\">Pr\u00E9c\u00E9dent</span>\r\n      </a>\r\n    </li>\r\n    <li *ngFor=\"let item of createRange(totalPages)\" class=\"page-item\" [ngClass]=\"pageNumber === item ? 'active' : ''\">\r\n      <a class=\"page-link\" (click)=\"goTo(item)\">{{ item }}</a>\r\n    </li>\r\n    <li class=\"page-item\">\r\n      <a class=\"page-link\" aria-label=\"Suivant\" (click)=\"goTo(+pageNumber + 1)\">\r\n        <span aria-hidden=\"true\">&raquo;</span>\r\n        <span class=\"sr-only\">Suivant</span>\r\n      </a>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { changePage: [{
            type: Output
        }], pageNumber: [{
            type: Input
        }], totalPages: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SnackbarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SnackbarComponent, [{
        type: Component,
        args: [{
                selector: 'nit-snackbar',
                template: "<div *ngIf=\"show\" @state [ngClass]=\"['snackbar-wrap', type]\">\r\n  <p class=\"snackbar-text\">\r\n    {{ message }}\r\n  </p>\r\n</div>\r\n",
                animations: [
                    trigger('state', [
                        transition(':enter', [
                            style({ bottom: '-100px', transform: 'translate(-50%, 0%) scale(0.3)' }),
                            animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({
                                transform: 'translate(-50%, 0%) scale(1)',
                                opacity: 1,
                                bottom: '20px'
                            }))
                        ]),
                        transition(':leave', [
                            animate('150ms cubic-bezier(0.4, 0.0, 1, 1)', style({
                                transform: 'translate(-50%, 0%) scale(0.3)',
                                opacity: 0,
                                bottom: '-100px'
                            }))
                        ])
                    ])
                ],
                styles: [".snackbar-wrap{position:fixed;bottom:50px;left:50%;padding:20px 0;border-radius:5px;min-width:20%;-webkit-transform-origin:center center;transform-origin:center center;-webkit-transform:translate(-50%,0);transform:translate(-50%,0)}.snackbar-wrap.success{background:#7ed321}.snackbar-wrap.danger{background:#ff3951}.snackbar-wrap .snackbar-text{text-align:center;font-size:1.3em;color:#fff;margin:0}"]
            }]
    }], function () { return [{ type: SnackbarService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardStatusPipe, [{
        type: Pipe,
        args: [{
                name: 'cardStatus'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BeneficiaryStatusPipe, [{
        type: Pipe,
        args: [{
                name: 'beneficiaryStatus'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DragAndDropDirective, [{
        type: Directive,
        args: [{
                selector: '[nitDragDrop]'
            }]
    }], function () { return []; }, { fileDropped: [{
            type: Output
        }], background: [{
            type: HostBinding,
            args: ['style.background-color']
        }], opacity: [{
            type: HostBinding,
            args: ['style.opacity']
        }], 
    // Dragover listener
    onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], 
    // Dragleave listener
    onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], 
    // Drop listener
    ondrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NitAngularLibModule, { declarations: function () { return [DebounceClickDirective, DragAndDropDirective, HiddenOnProdDirective, BeneficiaryStatusPipe, CardNumberPipe, CardStatusPipe, TokenComponent, AuthentificationComponent, DeconnexionComponent, CreditCardComponent, SpinnerButtonComponent, FormDiagnosticComponent, PaginationComponent, SnackbarComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CommonModule, DebounceClickDirective, DragAndDropDirective, HiddenOnProdDirective, BeneficiaryStatusPipe, CardNumberPipe, CardStatusPipe, TokenComponent, AuthentificationComponent, DeconnexionComponent, CreditCardComponent, SpinnerButtonComponent, FormDiagnosticComponent, PaginationComponent, SnackbarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NitAngularLibModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DebounceClickDirective,
                    DragAndDropDirective,
                    HiddenOnProdDirective,
                    BeneficiaryStatusPipe,
                    CardNumberPipe,
                    CardStatusPipe,
                    TokenComponent,
                    AuthentificationComponent,
                    DeconnexionComponent,
                    CreditCardComponent,
                    SpinnerButtonComponent,
                    FormDiagnosticComponent,
                    PaginationComponent,
                    SnackbarComponent,
                ],
                imports: [CommonModule],
                exports: [
                    CommonModule,
                    DebounceClickDirective,
                    DragAndDropDirective,
                    HiddenOnProdDirective,
                    BeneficiaryStatusPipe,
                    CardNumberPipe,
                    CardStatusPipe,
                    TokenComponent,
                    AuthentificationComponent,
                    DeconnexionComponent,
                    CreditCardComponent,
                    SpinnerButtonComponent,
                    FormDiagnosticComponent,
                    PaginationComponent,
                    SnackbarComponent
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthGuardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthentificationService }, { type: ɵngcc2.Router }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HttpRequestInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthentificationService }, { type: ɵngcc2.Router }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LangInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.TranslateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AffiliatesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApplicationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CharityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomerManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomerProductService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomerReportService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmployeeAffiliatesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmployeesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HoldersService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IndividualEmployerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MerchantService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OrderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProductsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ReferentialService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StructureService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserIDPService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VoucherService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProcessingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CreditNoteService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

/*
 * Public API Surface of nit-angular-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ALREADY_USED, ASC, AccountAdditionalInformation, AccountBeneficiary, AccountResponse, ActiveInactiveEnum, Address, AffiliateTypeEnum, AffiliatesService, Agreement, Amount, ApplicationMessage, ApplicationMessages, ApplicationService, AttachementPoint, AuthGuardService, AuthentificationComponent, AuthentificationService, BankDetails, BeneficiaryStatusPipe, Billing, BlockCardResponse, CODE, CardNumberPipe, CardRequestReport, CardRequestReports, CardRequestsReportsAdditionalInformationModel, CardService, CardStatusPipe, CardsReport, CardsReports, Categories, Category, ChannelEnum, CharityService, CheckingScratchAreaResponse, CompanyModel, ConditionTransitionEnum, ConjonctionEnum, Contact, Contract, ContractContact, CreateTermsAndConditions, CreditCardComponent, CreditNoteCreate, CreditNoteService, Criteria, Criterion, Customer, CustomerCardsAdditionalInformation, CustomerInfo, CustomerManagerService, CustomerProductService, CustomerReportService, CustomerService, CustomerStatusCardEnum, CustomizationOrderSubType, CustomizationOrderType, DESC, DebounceClickDirective, DeconnexionComponent, Delivery, DeliveryPoint, DeliveryPointDepartement, DeliveryPointProduct, DeliveryPointProductContact, DeliveryTypeEnum, DestinationEnum, DragAndDropDirective, EMPLOYEE_ID, Employee, EmployeeAffiliatesService, EmployeeContact, EmployeeContactRequest, EmployeeCreate, EmployeeCreationReport, EmployeeCreationReportsAdditionalInformation, EmployeeDeliveryMode, EmployeeError, EmployeeField, EmployeeFileCreate, EmployeeFileCustomer, EmployeeOrderRequest, EmployeeProduct, EmployeeResponse, EmployeeStructure, EmployeeSummary, EmployeeTransaction, EmployeeTransactionAffiliate, EmployeeTransactions, EmployeeValueSetting, EmployeeVoucherValue, Employees, EmployeesService, ErrorTypeEnum, FormDiagnosticComponent, FormatTitreEnum, HOLDER_ID, HiddenOnProdDirective, HoldersService, HttpRequestInterceptor, ITEM_EXPIRES, ITEM_SCOPE, ITEM_TOKEN, ITEM_USER, IncludeEnum, IndividualEmployerService, Intervention, InterventionResponse, InterventionVoucher, LABEL, LOGIN, LangInterceptor, LanguageEnum, LegalNotices, LineCreditNote, MerchantService, Motif, MotifBlocageStatus, MotifsOperation, NUMBER, NitAngularLibModule, Operation, OperationEnum, Optin, Order, OrderAnomaly, OrderBilledService, OrderCustomization, OrderFileCreate, OrderFileCustomer, OrderLine, OrderLineDetail, OrderLinesResponse, OrderOrigin, OrderRequestDetail, OrderRequestId, OrderRequestManager, OrderRequestManagerTypeEnum, OrderRequestParamBody, OrderRequestProcessingResponse, OrderRequestReport, OrderRequestReports, OrderRequestReportsAdditionalInformation, OrderRequestStatusUpdateProcessingBody, OrderRequestsAdditionnalInformation, OrderService, OrderStatusEnum, Orders, OriginTypeEnum, PROFILE, Page, PaginationComponent, Participant, Participants, PaymentMethodEnum, PeriodTypeEnum, Person, Personalisation, Processing, ProcessingError, ProcessingPriorityEnum, ProcessingResultEnum, ProcessingService, ProcessingStatusEnum, ProcessingSummaries, ProcessingSummary, ProcessingTypeEnum, Product, ProductsService, READY_TO_USE, ReadCardInfoResponse, ReadCardRequest, ReadCardRequestResponse, ReadTerm, ReadTerms, ReasonParamBody, ReceiverEmailAlertEnum, ReferentialService, RequestCardStatusEnum, RequestTypeEnum, SendingEmails, SimpleStatutDemandeEnum, SnackbarComponent, SpinnerButtonComponent, StatutDemandeEnum, StatutOperationEnum, StructureOrder, StructureService, StructureSummary, SubAccount, TARGET, TermAndCondition, TermsAndConditions, TitleEnum, TokenComponent, Transaction, TransactionEnum, TransactionMediumEnum, TransactionReasonFailureEnum, TransactionTypeEnum, Transactions, TransactionsReport, TransactionsReports, TypeContactEnum, USER_ID, User, UserActivation, UserActivationCreate, UserActivationRequest, UserActivationResponse, UserCreate, UserCriteria, UserIDPService, UserService, VintageEnum, Voucher, VoucherAccountResponse, VoucherAdditionalInformation, VoucherService, Vouchers, convertToCSV, dateFormat, dateFormatForScreen, downloadPdf, findHolderId, findProfile, getDayName, getEmployeeField, getMonthName, hasCapitalCaseRegex, hasLowerCaseLetterRegex, hasNumberRegex, hasSpecialCharacterRegex, merchantCategoryEnum, phoneRegex, toMMYY, SnackbarService as ɵa };

//# sourceMappingURL=nit-angular-lib.js.map